import * as i0 from '@angular/core';
import { Injectable, inject, NgModule } from '@angular/core';
import { map, mapTo, shareReplay } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
function enumStringToValue$8(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class DateRange {
  static fromProto(proto) {
    let m = new DateRange();
    m = Object.assign(m, proto);
    if (proto.start) {
      m.start = new Date(proto.start);
    }
    if (proto.end) {
      m.end = new Date(proto.end);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.start !== 'undefined' && this.start !== null) {
      toReturn['start'] = 'toApiJson' in this.start ? this.start.toApiJson() : this.start;
    }
    if (typeof this.end !== 'undefined' && this.end !== null) {
      toReturn['end'] = 'toApiJson' in this.end ? this.end.toApiJson() : this.end;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class EmailDomain {
  static fromProto(proto) {
    let m = new EmailDomain();
    m = Object.assign(m, proto);
    if (proto.mail) {
      m.mail = Record.fromProto(proto.mail);
    }
    if (proto.dkim1) {
      m.dkim1 = Record.fromProto(proto.dkim1);
    }
    if (proto.dkim2) {
      m.dkim2 = Record.fromProto(proto.dkim2);
    }
    if (proto.dmarc) {
      m.dmarc = Record.fromProto(proto.dmarc);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.mail !== 'undefined' && this.mail !== null) {
      toReturn['mail'] = 'toApiJson' in this.mail ? this.mail.toApiJson() : this.mail;
    }
    if (typeof this.dkim1 !== 'undefined' && this.dkim1 !== null) {
      toReturn['dkim1'] = 'toApiJson' in this.dkim1 ? this.dkim1.toApiJson() : this.dkim1;
    }
    if (typeof this.dkim2 !== 'undefined' && this.dkim2 !== null) {
      toReturn['dkim2'] = 'toApiJson' in this.dkim2 ? this.dkim2.toApiJson() : this.dkim2;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.subUserId !== 'undefined') {
      toReturn['subUserId'] = this.subUserId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.domainId !== 'undefined') {
      toReturn['domainId'] = this.domainId;
    }
    if (typeof this.sendAsEmail !== 'undefined') {
      toReturn['sendAsEmail'] = this.sendAsEmail;
    }
    if (typeof this.sendAsName !== 'undefined') {
      toReturn['sendAsName'] = this.sendAsName;
    }
    if (typeof this.dmarc !== 'undefined' && this.dmarc !== null) {
      toReturn['dmarc'] = 'toApiJson' in this.dmarc ? this.dmarc.toApiJson() : this.dmarc;
    }
    return toReturn;
  }
}
class Record {
  static fromProto(proto) {
    let m = new Record();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.subdomain !== 'undefined') {
      toReturn['subdomain'] = this.subdomain;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.currentValue !== 'undefined') {
      toReturn['currentValue'] = this.currentValue;
    }
    if (typeof this.verified !== 'undefined') {
      toReturn['verified'] = this.verified;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EventType = /*#__PURE__*/function (EventType) {
  EventType[EventType["EMPTY"] = 0] = "EMPTY";
  EventType[EventType["PROCESSED"] = 1] = "PROCESSED";
  EventType[EventType["DELIVERED"] = 2] = "DELIVERED";
  EventType[EventType["OPENED"] = 3] = "OPENED";
  EventType[EventType["CLICKED"] = 4] = "CLICKED";
  EventType[EventType["BOUNCED"] = 5] = "BOUNCED";
  EventType[EventType["DEFERRED"] = 6] = "DEFERRED";
  EventType[EventType["DROPPED"] = 7] = "DROPPED";
  EventType[EventType["SPAMREPORT"] = 8] = "SPAMREPORT";
  EventType[EventType["UNSUBSCRIBED"] = 9] = "UNSUBSCRIBED";
  EventType[EventType["RESUBSCRIBED"] = 10] = "RESUBSCRIBED";
  return EventType;
}(EventType || {});
var NotificationType = /*#__PURE__*/function (NotificationType) {
  NotificationType[NotificationType["NOTIFICATION_TYPE_PRODUCT_UPSELL"] = 0] = "NOTIFICATION_TYPE_PRODUCT_UPSELL";
  NotificationType[NotificationType["NOTIFICATION_TYPE_PRODUCT_ADOPTION"] = 1] = "NOTIFICATION_TYPE_PRODUCT_ADOPTION";
  NotificationType[NotificationType["NOTIFICATION_TYPE_CUSTOMER_ACQUISITION"] = 2] = "NOTIFICATION_TYPE_CUSTOMER_ACQUISITION";
  return NotificationType;
}(NotificationType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ContentContentType = /*#__PURE__*/function (ContentContentType) {
  ContentContentType[ContentContentType["TEXT_PLAIN"] = 0] = "TEXT_PLAIN";
  ContentContentType[ContentContentType["TEXT_HTML"] = 1] = "TEXT_HTML";
  return ContentContentType;
}(ContentContentType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var BounceSenderType = /*#__PURE__*/function (BounceSenderType) {
  BounceSenderType[BounceSenderType["UNBOUNCE_SENDER_TYPE_INVALID"] = 0] = "UNBOUNCE_SENDER_TYPE_INVALID";
  BounceSenderType[BounceSenderType["UNBOUNCE_SENDER_TYPE_PARTNER"] = 1] = "UNBOUNCE_SENDER_TYPE_PARTNER";
  BounceSenderType[BounceSenderType["UNBOUNCE_SENDER_TYPE_BUSINESS"] = 2] = "UNBOUNCE_SENDER_TYPE_BUSINESS";
  BounceSenderType[BounceSenderType["UNBOUNCE_SENDER_TYPE_YESWARE"] = 3] = "UNBOUNCE_SENDER_TYPE_YESWARE";
  return BounceSenderType;
}(BounceSenderType || {});
var ChangeEmailDomainStatus = /*#__PURE__*/function (ChangeEmailDomainStatus) {
  ChangeEmailDomainStatus[ChangeEmailDomainStatus["CHANGE_EMAIL_DOMAIN_STATUS_INVALID"] = 0] = "CHANGE_EMAIL_DOMAIN_STATUS_INVALID";
  ChangeEmailDomainStatus[ChangeEmailDomainStatus["CHANGE_EMAIL_DOMAIN_STATUS_ACCEPTED"] = 1] = "CHANGE_EMAIL_DOMAIN_STATUS_ACCEPTED";
  ChangeEmailDomainStatus[ChangeEmailDomainStatus["CHANGE_EMAIL_DOMAIN_STATUS_PENDING"] = 2] = "CHANGE_EMAIL_DOMAIN_STATUS_PENDING";
  return ChangeEmailDomainStatus;
}(ChangeEmailDomainStatus || {});
var EmailQueueStatus = /*#__PURE__*/function (EmailQueueStatus) {
  EmailQueueStatus[EmailQueueStatus["EMAIL_QUEUE_STATUS_UNSPECIFIED"] = 0] = "EMAIL_QUEUE_STATUS_UNSPECIFIED";
  EmailQueueStatus[EmailQueueStatus["EMAIL_QUEUE_STATUS_RUNNING"] = 1] = "EMAIL_QUEUE_STATUS_RUNNING";
  EmailQueueStatus[EmailQueueStatus["EMAIL_QUEUE_STATUS_DISABLED"] = 2] = "EMAIL_QUEUE_STATUS_DISABLED";
  return EmailQueueStatus;
}(EmailQueueStatus || {});
var Namespace = /*#__PURE__*/function (Namespace) {
  Namespace[Namespace["NAMESPACE_INVALID"] = 0] = "NAMESPACE_INVALID";
  Namespace[Namespace["NAMESPACE_EMAIL"] = 1] = "NAMESPACE_EMAIL";
  return Namespace;
}(Namespace || {});
var RecipientStatusEnum = /*#__PURE__*/function (RecipientStatusEnum) {
  RecipientStatusEnum[RecipientStatusEnum["RECIPIENT_STATUS_INVALID"] = 0] = "RECIPIENT_STATUS_INVALID";
  RecipientStatusEnum[RecipientStatusEnum["RECIPIENT_STATUS_HARD"] = 1] = "RECIPIENT_STATUS_HARD";
  RecipientStatusEnum[RecipientStatusEnum["RECIPIENT_STATUS_SOFT"] = 2] = "RECIPIENT_STATUS_SOFT";
  RecipientStatusEnum[RecipientStatusEnum["RECIPIENT_STATUS_UNKNOWN"] = 3] = "RECIPIENT_STATUS_UNKNOWN";
  RecipientStatusEnum[RecipientStatusEnum["RECIPIENT_STATUS_RESET"] = 4] = "RECIPIENT_STATUS_RESET";
  RecipientStatusEnum[RecipientStatusEnum["RECIPIENT_STATUS_NOT_BLOCKED"] = 5] = "RECIPIENT_STATUS_NOT_BLOCKED";
  return RecipientStatusEnum;
}(RecipientStatusEnum || {});
var SenderType = /*#__PURE__*/function (SenderType) {
  SenderType[SenderType["SENDER_TYPE_INVALID"] = 0] = "SENDER_TYPE_INVALID";
  SenderType[SenderType["SENDER_TYPE_PARTNER"] = 1] = "SENDER_TYPE_PARTNER";
  SenderType[SenderType["SENDER_TYPE_BUSINESS"] = 2] = "SENDER_TYPE_BUSINESS";
  return SenderType;
}(SenderType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class EmailEvent {
  static fromProto(proto) {
    let m = new EmailEvent();
    m = Object.assign(m, proto);
    if (proto.eventType) {
      m.eventType = enumStringToValue$5(EventType, proto.eventType);
    }
    if (proto.eventTime) {
      m.eventTime = new Date(proto.eventTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.eventTime !== 'undefined' && this.eventTime !== null) {
      toReturn['eventTime'] = 'toApiJson' in this.eventTime ? this.eventTime.toApiJson() : this.eventTime;
    }
    if (typeof this.ipAddress !== 'undefined') {
      toReturn['ipAddress'] = this.ipAddress;
    }
    if (typeof this.userAgent !== 'undefined') {
      toReturn['userAgent'] = this.userAgent;
    }
    if (typeof this.urlClicked !== 'undefined') {
      toReturn['urlClicked'] = this.urlClicked;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.urlClickedNormalized !== 'undefined') {
      toReturn['urlClickedNormalized'] = this.urlClickedNormalized;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Attribute {
  static fromProto(proto) {
    let m = new Attribute();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Bucket {
  static fromProto(proto) {
    let m = new Bucket();
    m = Object.assign(m, proto);
    if (proto.attribute) {
      m.attribute = Attribute.fromProto(proto.attribute);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bucketName !== 'undefined') {
      toReturn['bucketName'] = this.bucketName;
    }
    if (typeof this.attribute !== 'undefined' && this.attribute !== null) {
      toReturn['attribute'] = 'toApiJson' in this.attribute ? this.attribute.toApiJson() : this.attribute;
    }
    return toReturn;
  }
}
class ContactParticipant {
  static fromProto(proto) {
    let m = new ContactParticipant();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class Content {
  static fromProto(proto) {
    let m = new Content();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue$4(ContentContentType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.sensitive !== 'undefined') {
      toReturn['sensitive'] = this.sensitive;
    }
    return toReturn;
  }
}
class EmailMessage {
  static fromProto(proto) {
    let m = new EmailMessage();
    m = Object.assign(m, proto);
    if (proto.to) {
      m.to = proto.to.map(Participant.fromProto);
    }
    if (proto.cc) {
      m.cc = proto.cc.map(Participant.fromProto);
    }
    if (proto.bcc) {
      m.bcc = proto.bcc.map(Participant.fromProto);
    }
    if (proto.from) {
      m.from = Participant.fromProto(proto.from);
    }
    if (proto.replyTo) {
      m.replyTo = Participant.fromProto(proto.replyTo);
    }
    if (proto.content) {
      m.content = proto.content.map(Content.fromProto);
    }
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    if (proto.headers) {
      m.headers = proto.headers.map(Header.fromProto);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(GCSAttachment.fromProto);
    }
    if (proto.urlAttachments) {
      m.urlAttachments = proto.urlAttachments.map(URLAttachment.fromProto);
    }
    if (proto.serviceProviderInfo) {
      m.serviceProviderInfo = ServiceProviderInfo.fromProto(proto.serviceProviderInfo);
    }
    if (proto.links) {
      m.links = proto.links.map(Links.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.to !== 'undefined' && this.to !== null) {
      toReturn['to'] = 'toApiJson' in this.to ? this.to.toApiJson() : this.to;
    }
    if (typeof this.cc !== 'undefined' && this.cc !== null) {
      toReturn['cc'] = 'toApiJson' in this.cc ? this.cc.toApiJson() : this.cc;
    }
    if (typeof this.bcc !== 'undefined' && this.bcc !== null) {
      toReturn['bcc'] = 'toApiJson' in this.bcc ? this.bcc.toApiJson() : this.bcc;
    }
    if (typeof this.from !== 'undefined' && this.from !== null) {
      toReturn['from'] = 'toApiJson' in this.from ? this.from.toApiJson() : this.from;
    }
    if (typeof this.replyTo !== 'undefined' && this.replyTo !== null) {
      toReturn['replyTo'] = 'toApiJson' in this.replyTo ? this.replyTo.toApiJson() : this.replyTo;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    if (typeof this.headers !== 'undefined' && this.headers !== null) {
      toReturn['headers'] = 'toApiJson' in this.headers ? this.headers.toApiJson() : this.headers;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.urlAttachments !== 'undefined' && this.urlAttachments !== null) {
      toReturn['urlAttachments'] = 'toApiJson' in this.urlAttachments ? this.urlAttachments.toApiJson() : this.urlAttachments;
    }
    if (typeof this.serviceProviderInfo !== 'undefined' && this.serviceProviderInfo !== null) {
      toReturn['serviceProviderInfo'] = 'toApiJson' in this.serviceProviderInfo ? this.serviceProviderInfo.toApiJson() : this.serviceProviderInfo;
    }
    if (typeof this.links !== 'undefined' && this.links !== null) {
      toReturn['links'] = 'toApiJson' in this.links ? this.links.toApiJson() : this.links;
    }
    if (typeof this.originUserId !== 'undefined') {
      toReturn['originUserId'] = this.originUserId;
    }
    return toReturn;
  }
}
class EmailMessageV2 {
  static fromProto(proto) {
    let m = new EmailMessageV2();
    m = Object.assign(m, proto);
    if (proto.to) {
      m.to = UserParticipant.fromProto(proto.to);
    }
    if (proto.from) {
      m.from = Participant.fromProto(proto.from);
    }
    if (proto.replyTo) {
      m.replyTo = Participant.fromProto(proto.replyTo);
    }
    if (proto.content) {
      m.content = proto.content.map(Content.fromProto);
    }
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    if (proto.headers) {
      m.headers = proto.headers.map(Header.fromProto);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(GCSAttachment.fromProto);
    }
    if (proto.urlAttachments) {
      m.urlAttachments = proto.urlAttachments.map(URLAttachment.fromProto);
    }
    if (proto.serviceProviderInfo) {
      m.serviceProviderInfo = ServiceProviderInfo.fromProto(proto.serviceProviderInfo);
    }
    if (proto.links) {
      m.links = proto.links.map(Links.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.to !== 'undefined' && this.to !== null) {
      toReturn['to'] = 'toApiJson' in this.to ? this.to.toApiJson() : this.to;
    }
    if (typeof this.from !== 'undefined' && this.from !== null) {
      toReturn['from'] = 'toApiJson' in this.from ? this.from.toApiJson() : this.from;
    }
    if (typeof this.replyTo !== 'undefined' && this.replyTo !== null) {
      toReturn['replyTo'] = 'toApiJson' in this.replyTo ? this.replyTo.toApiJson() : this.replyTo;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    if (typeof this.headers !== 'undefined' && this.headers !== null) {
      toReturn['headers'] = 'toApiJson' in this.headers ? this.headers.toApiJson() : this.headers;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.urlAttachments !== 'undefined' && this.urlAttachments !== null) {
      toReturn['urlAttachments'] = 'toApiJson' in this.urlAttachments ? this.urlAttachments.toApiJson() : this.urlAttachments;
    }
    if (typeof this.serviceProviderInfo !== 'undefined' && this.serviceProviderInfo !== null) {
      toReturn['serviceProviderInfo'] = 'toApiJson' in this.serviceProviderInfo ? this.serviceProviderInfo.toApiJson() : this.serviceProviderInfo;
    }
    if (typeof this.links !== 'undefined' && this.links !== null) {
      toReturn['links'] = 'toApiJson' in this.links ? this.links.toApiJson() : this.links;
    }
    return toReturn;
  }
}
class EmailWithCustomDomainMessage {
  static fromProto(proto) {
    let m = new EmailWithCustomDomainMessage();
    m = Object.assign(m, proto);
    if (proto.to) {
      m.to = proto.to.map(Participant.fromProto);
    }
    if (proto.cc) {
      m.cc = proto.cc.map(Participant.fromProto);
    }
    if (proto.bcc) {
      m.bcc = proto.bcc.map(Participant.fromProto);
    }
    if (proto.replyTo) {
      m.replyTo = Participant.fromProto(proto.replyTo);
    }
    if (proto.content) {
      m.content = proto.content.map(Content.fromProto);
    }
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    if (proto.timestamp) {
      m.timestamp = new Date(proto.timestamp);
    }
    if (proto.headers) {
      m.headers = proto.headers.map(Header.fromProto);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(GCSAttachment.fromProto);
    }
    if (proto.urlAttachments) {
      m.urlAttachments = proto.urlAttachments.map(URLAttachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.to !== 'undefined' && this.to !== null) {
      toReturn['to'] = 'toApiJson' in this.to ? this.to.toApiJson() : this.to;
    }
    if (typeof this.cc !== 'undefined' && this.cc !== null) {
      toReturn['cc'] = 'toApiJson' in this.cc ? this.cc.toApiJson() : this.cc;
    }
    if (typeof this.bcc !== 'undefined' && this.bcc !== null) {
      toReturn['bcc'] = 'toApiJson' in this.bcc ? this.bcc.toApiJson() : this.bcc;
    }
    if (typeof this.replyTo !== 'undefined' && this.replyTo !== null) {
      toReturn['replyTo'] = 'toApiJson' in this.replyTo ? this.replyTo.toApiJson() : this.replyTo;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.content !== 'undefined' && this.content !== null) {
      toReturn['content'] = 'toApiJson' in this.content ? this.content.toApiJson() : this.content;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.timestamp !== 'undefined' && this.timestamp !== null) {
      toReturn['timestamp'] = 'toApiJson' in this.timestamp ? this.timestamp.toApiJson() : this.timestamp;
    }
    if (typeof this.headers !== 'undefined' && this.headers !== null) {
      toReturn['headers'] = 'toApiJson' in this.headers ? this.headers.toApiJson() : this.headers;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.urlAttachments !== 'undefined' && this.urlAttachments !== null) {
      toReturn['urlAttachments'] = 'toApiJson' in this.urlAttachments ? this.urlAttachments.toApiJson() : this.urlAttachments;
    }
    return toReturn;
  }
}
class GCSAttachment {
  static fromProto(proto) {
    let m = new GCSAttachment();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bucket !== 'undefined') {
      toReturn['bucket'] = this.bucket;
    }
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    if (typeof this.attachedFilename !== 'undefined') {
      toReturn['attachedFilename'] = this.attachedFilename;
    }
    return toReturn;
  }
}
class Header {
  static fromProto(proto) {
    let m = new Header();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class Links {
  static fromProto(proto) {
    let m = new Links();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.normalizedUrl !== 'undefined') {
      toReturn['normalizedUrl'] = this.normalizedUrl;
    }
    return toReturn;
  }
}
class Participant {
  static fromProto(proto) {
    let m = new Participant();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    return toReturn;
  }
}
class ServiceProviderInfo {
  static fromProto(proto) {
    let m = new ServiceProviderInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subUserId !== 'undefined') {
      toReturn['subUserId'] = this.subUserId;
    }
    return toReturn;
  }
}
class URLAttachment {
  static fromProto(proto) {
    let m = new URLAttachment();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    if (typeof this.attachedFilename !== 'undefined') {
      toReturn['attachedFilename'] = this.attachedFilename;
    }
    return toReturn;
  }
}
class UserParticipant {
  static fromProto(proto) {
    let m = new UserParticipant();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class WhiteLabelEmailMessage {
  static fromProto(proto) {
    let m = new WhiteLabelEmailMessage();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    if (proto.links) {
      m.links = proto.links.map(Links.fromProto);
    }
    if (proto.attachments) {
      m.attachments = proto.attachments.map(GCSAttachment.fromProto);
    }
    if (proto.urlAttachments) {
      m.urlAttachments = proto.urlAttachments.map(URLAttachment.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.htmlContent !== 'undefined') {
      toReturn['htmlContent'] = this.htmlContent;
    }
    if (typeof this.plainTextContent !== 'undefined') {
      toReturn['plainTextContent'] = this.plainTextContent;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.links !== 'undefined' && this.links !== null) {
      toReturn['links'] = 'toApiJson' in this.links ? this.links.toApiJson() : this.links;
    }
    if (typeof this.attachments !== 'undefined' && this.attachments !== null) {
      toReturn['attachments'] = 'toApiJson' in this.attachments ? this.attachments.toApiJson() : this.attachments;
    }
    if (typeof this.urlAttachments !== 'undefined' && this.urlAttachments !== null) {
      toReturn['urlAttachments'] = 'toApiJson' in this.urlAttachments ? this.urlAttachments.toApiJson() : this.urlAttachments;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PartnerEmailQuota {
  static fromProto(proto) {
    let m = new PartnerEmailQuota();
    m = Object.assign(m, proto);
    if (proto.dailyQuota) {
      m.dailyQuota = parseInt(proto.dailyQuota, 10);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.dailyQuota !== 'undefined') {
      toReturn['dailyQuota'] = this.dailyQuota;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AttachmentInfo {
  static fromProto(proto) {
    let m = new AttachmentInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filename !== 'undefined') {
      toReturn['filename'] = this.filename;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.contentType !== 'undefined') {
      toReturn['contentType'] = this.contentType;
    }
    if (typeof this.contentId !== 'undefined') {
      toReturn['contentId'] = this.contentId;
    }
    if (typeof this.charset !== 'undefined') {
      toReturn['charset'] = this.charset;
    }
    if (typeof this.storageObjectName !== 'undefined') {
      toReturn['storageObjectName'] = this.storageObjectName;
    }
    if (typeof this.storageObjectUrl !== 'undefined') {
      toReturn['storageObjectUrl'] = this.storageObjectUrl;
    }
    return toReturn;
  }
}
class Envelope {
  static fromProto(proto) {
    let m = new Envelope();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.toField !== 'undefined') {
      toReturn['toField'] = this.toField;
    }
    if (typeof this.fromField !== 'undefined') {
      toReturn['fromField'] = this.fromField;
    }
    return toReturn;
  }
}
class InboundMessage {
  static fromProto(proto) {
    let m = new InboundMessage();
    m = Object.assign(m, proto);
    if (proto.contentIds) {
      m.contentIds = proto.contentIds.map(Attribute.fromProto);
    }
    if (proto.toField) {
      m.toField = proto.toField.map(Participant.fromProto);
    }
    if (proto.fromField) {
      m.fromField = Participant.fromProto(proto.fromField);
    }
    if (proto.envelope) {
      m.envelope = Envelope.fromProto(proto.envelope);
    }
    if (proto.attachmentInfo) {
      m.attachmentInfo = proto.attachmentInfo.map(AttachmentInfo.fromProto);
    }
    if (proto.charsets) {
      m.charsets = proto.charsets.map(Attribute.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.headers !== 'undefined') {
      toReturn['headers'] = this.headers;
    }
    if (typeof this.dkim !== 'undefined') {
      toReturn['dkim'] = this.dkim;
    }
    if (typeof this.contentIds !== 'undefined' && this.contentIds !== null) {
      toReturn['contentIds'] = 'toApiJson' in this.contentIds ? this.contentIds.toApiJson() : this.contentIds;
    }
    if (typeof this.toField !== 'undefined' && this.toField !== null) {
      toReturn['toField'] = 'toApiJson' in this.toField ? this.toField.toApiJson() : this.toField;
    }
    if (typeof this.fromField !== 'undefined' && this.fromField !== null) {
      toReturn['fromField'] = 'toApiJson' in this.fromField ? this.fromField.toApiJson() : this.fromField;
    }
    if (typeof this.contentText !== 'undefined') {
      toReturn['contentText'] = this.contentText;
    }
    if (typeof this.contentHtml !== 'undefined') {
      toReturn['contentHtml'] = this.contentHtml;
    }
    if (typeof this.senderIp !== 'undefined') {
      toReturn['senderIp'] = this.senderIp;
    }
    if (typeof this.spamReport !== 'undefined') {
      toReturn['spamReport'] = this.spamReport;
    }
    if (typeof this.envelope !== 'undefined' && this.envelope !== null) {
      toReturn['envelope'] = 'toApiJson' in this.envelope ? this.envelope.toApiJson() : this.envelope;
    }
    if (typeof this.attachments !== 'undefined') {
      toReturn['attachments'] = this.attachments;
    }
    if (typeof this.attachmentInfo !== 'undefined' && this.attachmentInfo !== null) {
      toReturn['attachmentInfo'] = 'toApiJson' in this.attachmentInfo ? this.attachmentInfo.toApiJson() : this.attachmentInfo;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.spamScore !== 'undefined') {
      toReturn['spamScore'] = this.spamScore;
    }
    if (typeof this.charsets !== 'undefined' && this.charsets !== null) {
      toReturn['charsets'] = 'toApiJson' in this.charsets ? this.charsets.toApiJson() : this.charsets;
    }
    if (typeof this.spf !== 'undefined') {
      toReturn['spf'] = this.spf;
    }
    if (typeof this.rawMessage !== 'undefined') {
      toReturn['rawMessage'] = this.rawMessage;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class InboundMessageMapping {
  static fromProto(proto) {
    let m = new InboundMessageMapping();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mappingId !== 'undefined') {
      toReturn['mappingId'] = this.mappingId;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CheckDisposableEmailRequest {
  static fromProto(proto) {
    let m = new CheckDisposableEmailRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    return toReturn;
  }
}
class CheckDisposableEmailResponse {
  static fromProto(proto) {
    let m = new CheckDisposableEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isDisposable !== 'undefined') {
      toReturn['isDisposable'] = this.isDisposable;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AdminSetEmailQueuesStatusRequest {
  static fromProto(proto) {
    let m = new AdminSetEmailQueuesStatusRequest();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(EmailQueueStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class BatchSearchRecipientStatusRequest {
  static fromProto(proto) {
    let m = new BatchSearchRecipientStatusRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipientEmails !== 'undefined') {
      toReturn['recipientEmails'] = this.recipientEmails;
    }
    return toReturn;
  }
}
class BatchSearchRecipientStatusResponse {
  static fromProto(proto) {
    let m = new BatchSearchRecipientStatusResponse();
    m = Object.assign(m, proto);
    if (proto.recipientStatuses) {
      m.recipientStatuses = proto.recipientStatuses.map(Status.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientStatuses !== 'undefined' && this.recipientStatuses !== null) {
      toReturn['recipientStatuses'] = 'toApiJson' in this.recipientStatuses ? this.recipientStatuses.toApiJson() : this.recipientStatuses;
    }
    return toReturn;
  }
}
class BounceSender {
  static fromProto(proto) {
    let m = new BounceSender();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(BounceSenderType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class BulkUpsertPartnerEmailQuotaRequest {
  static fromProto(proto) {
    let m = new BulkUpsertPartnerEmailQuotaRequest();
    m = Object.assign(m, proto);
    if (proto.partnerEmailQuota) {
      m.partnerEmailQuota = proto.partnerEmailQuota.map(PartnerEmailQuotaMutation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerEmailQuota !== 'undefined' && this.partnerEmailQuota !== null) {
      toReturn['partnerEmailQuota'] = 'toApiJson' in this.partnerEmailQuota ? this.partnerEmailQuota.toApiJson() : this.partnerEmailQuota;
    }
    return toReturn;
  }
}
class Category {
  static fromProto(proto) {
    let m = new Category();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = enumStringToValue(Namespace, proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    return toReturn;
  }
}
class ChangeEmailDomainRequest {
  static fromProto(proto) {
    let m = new ChangeEmailDomainRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.sendFromDomain !== 'undefined') {
      toReturn['sendFromDomain'] = this.sendFromDomain;
    }
    if (typeof this.sendFromUsername !== 'undefined') {
      toReturn['sendFromUsername'] = this.sendFromUsername;
    }
    if (typeof this.replyToEmail !== 'undefined') {
      toReturn['replyToEmail'] = this.replyToEmail;
    }
    if (typeof this.sendFromName !== 'undefined') {
      toReturn['sendFromName'] = this.sendFromName;
    }
    return toReturn;
  }
}
class ChangeEmailDomainResponse {
  static fromProto(proto) {
    let m = new ChangeEmailDomainResponse();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(ChangeEmailDomainStatus, proto.status);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    return toReturn;
  }
}
class CreateBlockRequest {
  static fromProto(proto) {
    let m = new CreateBlockRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blockType !== 'undefined') {
      toReturn['blockType'] = this.blockType;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.conditions !== 'undefined') {
      toReturn['conditions'] = this.conditions;
    }
    return toReturn;
  }
}
class CreateBlockResponse {
  static fromProto(proto) {
    let m = new CreateBlockResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blockType !== 'undefined') {
      toReturn['blockType'] = this.blockType;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateEmailDomainRequest {
  static fromProto(proto) {
    let m = new CreateEmailDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class CreateEmailDomainWithSendAsRequest {
  static fromProto(proto) {
    let m = new CreateEmailDomainWithSendAsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.sendAsEmail !== 'undefined') {
      toReturn['sendAsEmail'] = this.sendAsEmail;
    }
    if (typeof this.sendAsName !== 'undefined') {
      toReturn['sendAsName'] = this.sendAsName;
    }
    return toReturn;
  }
}
class CreateInboundMessageMappingRequest {
  static fromProto(proto) {
    let m = new CreateInboundMessageMappingRequest();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}
class CreateInboundMessageMappingResponse {
  static fromProto(proto) {
    let m = new CreateInboundMessageMappingResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mappingId !== 'undefined') {
      toReturn['mappingId'] = this.mappingId;
    }
    return toReturn;
  }
}
class CreatePendingDomainRequest {
  static fromProto(proto) {
    let m = new CreatePendingDomainRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class CustomSender {
  static fromProto(proto) {
    let m = new CustomSender();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customEmailUsername !== 'undefined') {
      toReturn['customEmailUsername'] = this.customEmailUsername;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.replyTo !== 'undefined') {
      toReturn['replyTo'] = this.replyTo;
    }
    return toReturn;
  }
}
class DeleteBlockRequest {
  static fromProto(proto) {
    let m = new DeleteBlockRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blockType !== 'undefined') {
      toReturn['blockType'] = this.blockType;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class DeleteEmailDomainRequest {
  static fromProto(proto) {
    let m = new DeleteEmailDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class DeletePartnerEmailQuotaRequest {
  static fromProto(proto) {
    let m = new DeletePartnerEmailQuotaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class DeletePendingEmailDomainRequest {
  static fromProto(proto) {
    let m = new DeletePendingEmailDomainRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class DeleteSubUserRequest {
  static fromProto(proto) {
    let m = new DeleteSubUserRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    return toReturn;
  }
}
class EmailEventBucket {
  static fromProto(proto) {
    let m = new EmailEventBucket();
    m = Object.assign(m, proto);
    if (proto.eventRollup) {
      m.eventRollup = proto.eventRollup.map(EmailEventBucketEventRollup.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.bucketName !== 'undefined') {
      toReturn['bucketName'] = this.bucketName;
    }
    if (typeof this.eventRollup !== 'undefined' && this.eventRollup !== null) {
      toReturn['eventRollup'] = 'toApiJson' in this.eventRollup ? this.eventRollup.toApiJson() : this.eventRollup;
    }
    return toReturn;
  }
}
class EmailEventFilter {
  static fromProto(proto) {
    let m = new EmailEventFilter();
    m = Object.assign(m, proto);
    if (proto.notificationTypes) {
      m.notificationTypes = proto.notificationTypes.map(v => enumStringToValue(NotificationType, v));
    }
    if (proto.eventTypes) {
      m.eventTypes = proto.eventTypes.map(v => enumStringToValue(EventType, v));
    }
    if (proto.dateRange) {
      m.dateRange = DateRange.fromProto(proto.dateRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.notificationTypes !== 'undefined') {
      toReturn['notificationTypes'] = this.notificationTypes;
    }
    if (typeof this.eventTypes !== 'undefined') {
      toReturn['eventTypes'] = this.eventTypes;
    }
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? this.dateRange.toApiJson() : this.dateRange;
    }
    return toReturn;
  }
}
class EmailEventBucketEventRollup {
  static fromProto(proto) {
    let m = new EmailEventBucketEventRollup();
    m = Object.assign(m, proto);
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.quantity) {
      m.quantity = parseInt(proto.quantity, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.quantity !== 'undefined') {
      toReturn['quantity'] = this.quantity;
    }
    return toReturn;
  }
}
class GetAttributeEventStatsResponseEventStats {
  static fromProto(proto) {
    let m = new GetAttributeEventStatsResponseEventStats();
    m = Object.assign(m, proto);
    if (proto.eventType) {
      m.eventType = enumStringToValue(EventType, proto.eventType);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    if (proto.uniqueCount) {
      m.uniqueCount = parseInt(proto.uniqueCount, 10);
    }
    if (proto.uniqueRecipients) {
      m.uniqueRecipients = parseInt(proto.uniqueRecipients, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventType !== 'undefined') {
      toReturn['eventType'] = this.eventType;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    if (typeof this.uniqueCount !== 'undefined') {
      toReturn['uniqueCount'] = this.uniqueCount;
    }
    if (typeof this.uniqueRecipients !== 'undefined') {
      toReturn['uniqueRecipients'] = this.uniqueRecipients;
    }
    return toReturn;
  }
}
class ExportAttributeEventClickStatsRequest {
  static fromProto(proto) {
    let m = new ExportAttributeEventClickStatsRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.attribute) {
      m.attribute = Attribute.fromProto(proto.attribute);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.normalizedUrl !== 'undefined') {
      toReturn['normalizedUrl'] = this.normalizedUrl;
    }
    if (typeof this.attribute !== 'undefined' && this.attribute !== null) {
      toReturn['attribute'] = 'toApiJson' in this.attribute ? this.attribute.toApiJson() : this.attribute;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class GetAttributeEventLinkStatsRequest {
  static fromProto(proto) {
    let m = new GetAttributeEventLinkStatsRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.attribute) {
      m.attribute = Attribute.fromProto(proto.attribute);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.attribute !== 'undefined' && this.attribute !== null) {
      toReturn['attribute'] = 'toApiJson' in this.attribute ? this.attribute.toApiJson() : this.attribute;
    }
    return toReturn;
  }
}
class GetAttributeEventLinkStatsResponse {
  static fromProto(proto) {
    let m = new GetAttributeEventLinkStatsResponse();
    m = Object.assign(m, proto);
    if (proto.data) {
      m.data = proto.data.map(LinkStats.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    return toReturn;
  }
}
class GetAttributeEventStatsRequest {
  static fromProto(proto) {
    let m = new GetAttributeEventStatsRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.attribute) {
      m.attribute = Attribute.fromProto(proto.attribute);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.attribute !== 'undefined' && this.attribute !== null) {
      toReturn['attribute'] = 'toApiJson' in this.attribute ? this.attribute.toApiJson() : this.attribute;
    }
    return toReturn;
  }
}
class GetAttributeEventStatsResponse {
  static fromProto(proto) {
    let m = new GetAttributeEventStatsResponse();
    m = Object.assign(m, proto);
    if (proto.data) {
      m.data = proto.data.map(GetAttributeEventStatsResponseEventStats.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    return toReturn;
  }
}
class GetBlockRequest {
  static fromProto(proto) {
    let m = new GetBlockRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blockType !== 'undefined') {
      toReturn['blockType'] = this.blockType;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetBlockResponse {
  static fromProto(proto) {
    let m = new GetBlockResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.blockType !== 'undefined') {
      toReturn['blockType'] = this.blockType;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.conditions !== 'undefined') {
      toReturn['conditions'] = this.conditions;
    }
    return toReturn;
  }
}
class GetBouncedRecipientRequest {
  static fromProto(proto) {
    let m = new GetBouncedRecipientRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = BounceSender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    return toReturn;
  }
}
class GetBouncedRecipientResponse {
  static fromProto(proto) {
    let m = new GetBouncedRecipientResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    return toReturn;
  }
}
class GetCategoriesRequest {
  static fromProto(proto) {
    let m = new GetCategoriesRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    return toReturn;
  }
}
class GetCategoriesResponse {
  static fromProto(proto) {
    let m = new GetCategoriesResponse();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(Category.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    return toReturn;
  }
}
class GetCategoryPreferencesRequest {
  static fromProto(proto) {
    let m = new GetCategoryPreferencesRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.recipientId !== 'undefined') {
      toReturn['recipientId'] = this.recipientId;
    }
    return toReturn;
  }
}
class GetCategoryPreferencesResponse {
  static fromProto(proto) {
    let m = new GetCategoryPreferencesResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.optedInEmailCategoryIds !== 'undefined') {
      toReturn['optedInEmailCategoryIds'] = this.optedInEmailCategoryIds;
    }
    if (typeof this.emailPreferenceInitialized !== 'undefined') {
      toReturn['emailPreferenceInitialized'] = this.emailPreferenceInitialized;
    }
    return toReturn;
  }
}
class GetDefaultDomainRequest {
  static fromProto(proto) {
    let m = new GetDefaultDomainRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    return toReturn;
  }
}
class GetDefaultDomainResponse {
  static fromProto(proto) {
    let m = new GetDefaultDomainResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    return toReturn;
  }
}
class GetEmailDomainRequest {
  static fromProto(proto) {
    let m = new GetEmailDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class GetEmailDomainResponse {
  static fromProto(proto) {
    let m = new GetEmailDomainResponse();
    m = Object.assign(m, proto);
    if (proto.domain) {
      m.domain = EmailDomain.fromProto(proto.domain);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined' && this.domain !== null) {
      toReturn['domain'] = 'toApiJson' in this.domain ? this.domain.toApiJson() : this.domain;
    }
    return toReturn;
  }
}
class GetEmailQueuesStatusRequest {
  static fromProto(proto) {
    let m = new GetEmailQueuesStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class GetEmailQueuesStatusResponse {
  static fromProto(proto) {
    let m = new GetEmailQueuesStatusResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.running !== 'undefined') {
      toReturn['running'] = this.running;
    }
    return toReturn;
  }
}
class GetInboundMessageMappingRequest {
  static fromProto(proto) {
    let m = new GetInboundMessageMappingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
class GetInboundMessageMappingResponse {
  static fromProto(proto) {
    let m = new GetInboundMessageMappingResponse();
    m = Object.assign(m, proto);
    if (proto.inboundMessageMapping) {
      m.inboundMessageMapping = InboundMessageMapping.fromProto(proto.inboundMessageMapping);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inboundMessageMapping !== 'undefined' && this.inboundMessageMapping !== null) {
      toReturn['inboundMessageMapping'] = 'toApiJson' in this.inboundMessageMapping ? this.inboundMessageMapping.toApiJson() : this.inboundMessageMapping;
    }
    return toReturn;
  }
}
class GetInboundMessageRequest {
  static fromProto(proto) {
    let m = new GetInboundMessageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    return toReturn;
  }
}
class GetInboundMessageResponse {
  static fromProto(proto) {
    let m = new GetInboundMessageResponse();
    m = Object.assign(m, proto);
    if (proto.inboundMessage) {
      m.inboundMessage = InboundMessage.fromProto(proto.inboundMessage);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inboundMessage !== 'undefined' && this.inboundMessage !== null) {
      toReturn['inboundMessage'] = 'toApiJson' in this.inboundMessage ? this.inboundMessage.toApiJson() : this.inboundMessage;
    }
    return toReturn;
  }
}
class GetMessageRequest {
  static fromProto(proto) {
    let m = new GetMessageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    return toReturn;
  }
}
class GetMessageResponse {
  static fromProto(proto) {
    let m = new GetMessageResponse();
    m = Object.assign(m, proto);
    if (proto.message) {
      m.message = EmailMessage.fromProto(proto.message);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.message !== 'undefined' && this.message !== null) {
      toReturn['message'] = 'toApiJson' in this.message ? this.message.toApiJson() : this.message;
    }
    return toReturn;
  }
}
class GetMultiEmailRollupsRequest {
  static fromProto(proto) {
    let m = new GetMultiEmailRollupsRequest();
    m = Object.assign(m, proto);
    if (proto.buckets) {
      m.buckets = proto.buckets.map(Bucket.fromProto);
    }
    if (proto.filter) {
      m.filter = EmailEventFilter.fromProto(proto.filter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.buckets !== 'undefined' && this.buckets !== null) {
      toReturn['buckets'] = 'toApiJson' in this.buckets ? this.buckets.toApiJson() : this.buckets;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    return toReturn;
  }
}
class GetMultiEmailRollupsResponse {
  static fromProto(proto) {
    let m = new GetMultiEmailRollupsResponse();
    m = Object.assign(m, proto);
    if (proto.emailRollups) {
      m.emailRollups = proto.emailRollups.map(EmailEventBucket.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailRollups !== 'undefined' && this.emailRollups !== null) {
      toReturn['emailRollups'] = 'toApiJson' in this.emailRollups ? this.emailRollups.toApiJson() : this.emailRollups;
    }
    return toReturn;
  }
}
class GetMultiMessageRequest {
  static fromProto(proto) {
    let m = new GetMultiMessageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailIds !== 'undefined') {
      toReturn['emailIds'] = this.emailIds;
    }
    return toReturn;
  }
}
class GetMultiMessageResponse {
  static fromProto(proto) {
    let m = new GetMultiMessageResponse();
    m = Object.assign(m, proto);
    if (proto.messages) {
      m.messages = proto.messages.map(EmailMessage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.messages !== 'undefined' && this.messages !== null) {
      toReturn['messages'] = 'toApiJson' in this.messages ? this.messages.toApiJson() : this.messages;
    }
    return toReturn;
  }
}
class GetMultiPartnerEmailQuotaRequest {
  static fromProto(proto) {
    let m = new GetMultiPartnerEmailQuotaRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerIds !== 'undefined') {
      toReturn['partnerIds'] = this.partnerIds;
    }
    return toReturn;
  }
}
class GetMultiPartnerEmailQuotaResponse {
  static fromProto(proto) {
    let m = new GetMultiPartnerEmailQuotaResponse();
    m = Object.assign(m, proto);
    if (proto.partnerEmailQuotas) {
      m.partnerEmailQuotas = proto.partnerEmailQuotas.map(PartnerEmailQuota.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerEmailQuotas !== 'undefined' && this.partnerEmailQuotas !== null) {
      toReturn['partnerEmailQuotas'] = 'toApiJson' in this.partnerEmailQuotas ? this.partnerEmailQuotas.toApiJson() : this.partnerEmailQuotas;
    }
    return toReturn;
  }
}
class GetPendingEmailDomainRequest {
  static fromProto(proto) {
    let m = new GetPendingEmailDomainRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    return toReturn;
  }
}
class GetPendingEmailDomainResponse {
  static fromProto(proto) {
    let m = new GetPendingEmailDomainResponse();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    if (proto.targets) {
      m.targets = GetPendingEmailDomainTargetCNameRecords.fromProto(proto.targets);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.sendFromDomain !== 'undefined') {
      toReturn['sendFromDomain'] = this.sendFromDomain;
    }
    if (typeof this.targetSpf !== 'undefined') {
      toReturn['targetSpf'] = this.targetSpf;
    }
    if (typeof this.currentSpf !== 'undefined') {
      toReturn['currentSpf'] = this.currentSpf;
    }
    if (typeof this.sendFromUsername !== 'undefined') {
      toReturn['sendFromUsername'] = this.sendFromUsername;
    }
    if (typeof this.targets !== 'undefined' && this.targets !== null) {
      toReturn['targets'] = 'toApiJson' in this.targets ? this.targets.toApiJson() : this.targets;
    }
    return toReturn;
  }
}
class GetPendingEmailDomainTargetCNameRecords {
  static fromProto(proto) {
    let m = new GetPendingEmailDomainTargetCNameRecords();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.mailSubdomain !== 'undefined') {
      toReturn['mailSubdomain'] = this.mailSubdomain;
    }
    if (typeof this.mailValue !== 'undefined') {
      toReturn['mailValue'] = this.mailValue;
    }
    if (typeof this.dkim1Subdomain !== 'undefined') {
      toReturn['dkim1Subdomain'] = this.dkim1Subdomain;
    }
    if (typeof this.dkim1Value !== 'undefined') {
      toReturn['dkim1Value'] = this.dkim1Value;
    }
    if (typeof this.dkim2Subdomain !== 'undefined') {
      toReturn['dkim2Subdomain'] = this.dkim2Subdomain;
    }
    if (typeof this.dkim2Value !== 'undefined') {
      toReturn['dkim2Value'] = this.dkim2Value;
    }
    if (typeof this.dmarcSubdomain !== 'undefined') {
      toReturn['dmarcSubdomain'] = this.dmarcSubdomain;
    }
    if (typeof this.dmarcValue !== 'undefined') {
      toReturn['dmarcValue'] = this.dmarcValue;
    }
    return toReturn;
  }
}
class GetReplyEmailRequest {
  static fromProto(proto) {
    let m = new GetReplyEmailRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    return toReturn;
  }
}
class GetReplyEmailResponse {
  static fromProto(proto) {
    let m = new GetReplyEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.replyAddress !== 'undefined') {
      toReturn['replyAddress'] = this.replyAddress;
    }
    return toReturn;
  }
}
class GetSenderInfoRequest {
  static fromProto(proto) {
    let m = new GetSenderInfoRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class GetSenderInfoResponse {
  static fromProto(proto) {
    let m = new GetSenderInfoResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domain !== 'undefined') {
      toReturn['domain'] = this.domain;
    }
    if (typeof this.isPlatformAuthorized !== 'undefined') {
      toReturn['isPlatformAuthorized'] = this.isPlatformAuthorized;
    }
    if (typeof this.isDefaultForSenderType !== 'undefined') {
      toReturn['isDefaultForSenderType'] = this.isDefaultForSenderType;
    }
    if (typeof this.preferredEmailUsername !== 'undefined') {
      toReturn['preferredEmailUsername'] = this.preferredEmailUsername;
    }
    if (typeof this.preferredEmailDisplayName !== 'undefined') {
      toReturn['preferredEmailDisplayName'] = this.preferredEmailDisplayName;
    }
    if (typeof this.preferredReplyToEmailAddress !== 'undefined') {
      toReturn['preferredReplyToEmailAddress'] = this.preferredReplyToEmailAddress;
    }
    return toReturn;
  }
}
class GetUnsubscribeLinkRequest {
  static fromProto(proto) {
    let m = new GetUnsubscribeLinkRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetUnsubscribeLinkResponse {
  static fromProto(proto) {
    let m = new GetUnsubscribeLinkResponse();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.recipientIds !== 'undefined') {
      toReturn['recipientIds'] = this.recipientIds;
    }
    return toReturn;
  }
}
class GetUnsubscribedRecipientRequest {
  static fromProto(proto) {
    let m = new GetUnsubscribedRecipientRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    return toReturn;
  }
}
class GetUnsubscribedRecipientResponse {
  static fromProto(proto) {
    let m = new GetUnsubscribedRecipientResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    return toReturn;
  }
}
class InboundMessageMappingOptions {
  static fromProto(proto) {
    let m = new InboundMessageMappingOptions();
    m = Object.assign(m, proto);
    if (proto.attributes) {
      m.attributes = proto.attributes.map(Attribute.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.attributes !== 'undefined' && this.attributes !== null) {
      toReturn['attributes'] = 'toApiJson' in this.attributes ? this.attributes.toApiJson() : this.attributes;
    }
    return toReturn;
  }
}
class InitializeSubUserRequest {
  static fromProto(proto) {
    let m = new InitializeSubUserRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    return toReturn;
  }
}
class InitiateEmailDomainRectifyRequest {
  static fromProto(proto) {
    let m = new InitiateEmailDomainRectifyRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.bypassFrequencyLimit !== 'undefined') {
      toReturn['bypassFrequencyLimit'] = this.bypassFrequencyLimit;
    }
    return toReturn;
  }
}
class InitiateEmailDomainRollbackRequest {
  static fromProto(proto) {
    let m = new InitiateEmailDomainRollbackRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    return toReturn;
  }
}
class LinkClickStats {
  static fromProto(proto) {
    let m = new LinkClickStats();
    m = Object.assign(m, proto);
    if (proto.recipient) {
      m.recipient = LinkClickStatsRecipient.fromProto(proto.recipient);
    }
    if (proto.recentDate) {
      m.recentDate = new Date(proto.recentDate);
    }
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.recentDate !== 'undefined' && this.recentDate !== null) {
      toReturn['recentDate'] = 'toApiJson' in this.recentDate ? this.recentDate.toApiJson() : this.recentDate;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class LinkStats {
  static fromProto(proto) {
    let m = new LinkStats();
    m = Object.assign(m, proto);
    if (proto.totalClicks) {
      m.totalClicks = parseInt(proto.totalClicks, 10);
    }
    if (proto.uniqueClicks) {
      m.uniqueClicks = parseInt(proto.uniqueClicks, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.totalClicks !== 'undefined') {
      toReturn['totalClicks'] = this.totalClicks;
    }
    if (typeof this.uniqueClicks !== 'undefined') {
      toReturn['uniqueClicks'] = this.uniqueClicks;
    }
    if (typeof this.clickRate !== 'undefined') {
      toReturn['clickRate'] = this.clickRate;
    }
    return toReturn;
  }
}
class ListAllDomainsRequest {
  static fromProto(proto) {
    let m = new ListAllDomainsRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class ListAllDomainsResponse {
  static fromProto(proto) {
    let m = new ListAllDomainsResponse();
    m = Object.assign(m, proto);
    if (proto.domains) {
      m.domains = proto.domains.map(SenderDomain.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.domains !== 'undefined' && this.domains !== null) {
      toReturn['domains'] = 'toApiJson' in this.domains ? this.domains.toApiJson() : this.domains;
    }
    return toReturn;
  }
}
class ListEmailEventsRequestListEmailEventsFilters {
  static fromProto(proto) {
    let m = new ListEmailEventsRequestListEmailEventsFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class ListEmailEventsRequest {
  static fromProto(proto) {
    let m = new ListEmailEventsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListEmailEventsRequestListEmailEventsFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListEmailEventsResponse {
  static fromProto(proto) {
    let m = new ListEmailEventsResponse();
    m = Object.assign(m, proto);
    if (proto.events) {
      m.events = proto.events.map(EmailEvent.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.events !== 'undefined' && this.events !== null) {
      toReturn['events'] = 'toApiJson' in this.events ? this.events.toApiJson() : this.events;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    return toReturn;
  }
}
class ListEmailsRequestListEmailsFilters {
  static fromProto(proto) {
    let m = new ListEmailsRequestListEmailsFilters();
    m = Object.assign(m, proto);
    if (proto.dateRange) {
      m.dateRange = DateRange.fromProto(proto.dateRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.to !== 'undefined') {
      toReturn['to'] = this.to;
    }
    if (typeof this.from !== 'undefined') {
      toReturn['from'] = this.from;
    }
    if (typeof this.dateRange !== 'undefined' && this.dateRange !== null) {
      toReturn['dateRange'] = 'toApiJson' in this.dateRange ? this.dateRange.toApiJson() : this.dateRange;
    }
    if (typeof this.espId !== 'undefined') {
      toReturn['espId'] = this.espId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.espIds !== 'undefined') {
      toReturn['espIds'] = this.espIds;
    }
    if (typeof this.subuserId !== 'undefined') {
      toReturn['subuserId'] = this.subuserId;
    }
    return toReturn;
  }
}
class ListEmailsRequest {
  static fromProto(proto) {
    let m = new ListEmailsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListEmailsRequestListEmailsFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListEmailsResponse {
  static fromProto(proto) {
    let m = new ListEmailsResponse();
    m = Object.assign(m, proto);
    if (proto.emails) {
      m.emails = proto.emails.map(EmailMessage.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emails !== 'undefined' && this.emails !== null) {
      toReturn['emails'] = 'toApiJson' in this.emails ? this.emails.toApiJson() : this.emails;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListEventsForAttributesRequest {
  static fromProto(proto) {
    let m = new ListEventsForAttributesRequest();
    m = Object.assign(m, proto);
    if (proto.attribute) {
      m.attribute = Attribute.fromProto(proto.attribute);
    }
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.eventTypes) {
      m.eventTypes = proto.eventTypes.map(v => enumStringToValue(EventType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.attribute !== 'undefined' && this.attribute !== null) {
      toReturn['attribute'] = 'toApiJson' in this.attribute ? this.attribute.toApiJson() : this.attribute;
    }
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.eventTypes !== 'undefined') {
      toReturn['eventTypes'] = this.eventTypes;
    }
    return toReturn;
  }
}
class ListEventsForAttributesResponse {
  static fromProto(proto) {
    let m = new ListEventsForAttributesResponse();
    m = Object.assign(m, proto);
    if (proto.events) {
      m.events = proto.events.map(EmailEvent.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.events !== 'undefined' && this.events !== null) {
      toReturn['events'] = 'toApiJson' in this.events ? this.events.toApiJson() : this.events;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListLinkClickActivityForAttributeRequest {
  static fromProto(proto) {
    let m = new ListLinkClickActivityForAttributeRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.attribute) {
      m.attribute = Attribute.fromProto(proto.attribute);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = ListLinkClickActivityForAttributeRequestPagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.attribute !== 'undefined' && this.attribute !== null) {
      toReturn['attribute'] = 'toApiJson' in this.attribute ? this.attribute.toApiJson() : this.attribute;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.normalizedUrl !== 'undefined') {
      toReturn['normalizedUrl'] = this.normalizedUrl;
    }
    return toReturn;
  }
}
class ListLinkClickActivityForAttributeResponse {
  static fromProto(proto) {
    let m = new ListLinkClickActivityForAttributeResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    if (proto.data) {
      m.data = proto.data.map(LinkClickStats.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    return toReturn;
  }
}
class ListSendGridSubUserReputationsRequest {
  static fromProto(proto) {
    let m = new ListSendGridSubUserReputationsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.cursor) {
      m.cursor = parseInt(proto.cursor, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    return toReturn;
  }
}
class ListSendGridSubUserReputationsResponse {
  static fromProto(proto) {
    let m = new ListSendGridSubUserReputationsResponse();
    m = Object.assign(m, proto);
    if (proto.reputations) {
      m.reputations = proto.reputations.map(SendGridSubUserReputation.fromProto);
    }
    if (proto.nextCursor) {
      m.nextCursor = parseInt(proto.nextCursor, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reputations !== 'undefined' && this.reputations !== null) {
      toReturn['reputations'] = 'toApiJson' in this.reputations ? this.reputations.toApiJson() : this.reputations;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    return toReturn;
  }
}
class ListSendGridTeammatesRequest {
  static fromProto(proto) {
    let m = new ListSendGridTeammatesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    return toReturn;
  }
}
class ListSendGridTeammatesResponse {
  static fromProto(proto) {
    let m = new ListSendGridTeammatesResponse();
    m = Object.assign(m, proto);
    if (proto.teammates) {
      m.teammates = proto.teammates.map(SendGridTeammate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.teammates !== 'undefined' && this.teammates !== null) {
      toReturn['teammates'] = 'toApiJson' in this.teammates ? this.teammates.toApiJson() : this.teammates;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListLinkClickActivityForAttributeRequestPagedRequestOptions {
  static fromProto(proto) {
    let m = new ListLinkClickActivityForAttributeRequestPagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class PartnerEmailQuotaMutation {
  static fromProto(proto) {
    let m = new PartnerEmailQuotaMutation();
    m = Object.assign(m, proto);
    if (proto.dailyQuota) {
      m.dailyQuota = parseInt(proto.dailyQuota, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.dailyQuota !== 'undefined') {
      toReturn['dailyQuota'] = this.dailyQuota;
    }
    return toReturn;
  }
}
class QuarantineSenderRequest {
  static fromProto(proto) {
    let m = new QuarantineSenderRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    return toReturn;
  }
}
class LinkClickStatsRecipient {
  static fromProto(proto) {
    let m = new LinkClickStatsRecipient();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailAddress !== 'undefined') {
      toReturn['emailAddress'] = this.emailAddress;
    }
    return toReturn;
  }
}
class RedirectEmailRequest {
  static fromProto(proto) {
    let m = new RedirectEmailRequest();
    m = Object.assign(m, proto);
    if (proto.override) {
      m.override = EmailMessage.fromProto(proto.override);
    }
    if (proto.overrideSender) {
      m.overrideSender = Sender.fromProto(proto.overrideSender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.authCheckOnly !== 'undefined') {
      toReturn['authCheckOnly'] = this.authCheckOnly;
    }
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.newRecipientEmailAddress !== 'undefined') {
      toReturn['newRecipientEmailAddress'] = this.newRecipientEmailAddress;
    }
    if (typeof this.includeContent !== 'undefined') {
      toReturn['includeContent'] = this.includeContent;
    }
    if (typeof this.includeAttributes !== 'undefined') {
      toReturn['includeAttributes'] = this.includeAttributes;
    }
    if (typeof this.override !== 'undefined' && this.override !== null) {
      toReturn['override'] = 'toApiJson' in this.override ? this.override.toApiJson() : this.override;
    }
    if (typeof this.overrideSender !== 'undefined' && this.overrideSender !== null) {
      toReturn['overrideSender'] = 'toApiJson' in this.overrideSender ? this.overrideSender.toApiJson() : this.overrideSender;
    }
    return toReturn;
  }
}
class RedirectEmailResponse {
  static fromProto(proto) {
    let m = new RedirectEmailResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.newEmailId !== 'undefined') {
      toReturn['newEmailId'] = this.newEmailId;
    }
    return toReturn;
  }
}
class ResetRecipientStatusRequest {
  static fromProto(proto) {
    let m = new ResetRecipientStatusRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    return toReturn;
  }
}
class ResubscribeRecipientFromUnsubscribeLinkRequest {
  static fromProto(proto) {
    let m = new ResubscribeRecipientFromUnsubscribeLinkRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.unsubscribeLinkUrl !== 'undefined') {
      toReturn['unsubscribeLinkUrl'] = this.unsubscribeLinkUrl;
    }
    if (typeof this.unsubscribeLinkId !== 'undefined') {
      toReturn['unsubscribeLinkId'] = this.unsubscribeLinkId;
    }
    return toReturn;
  }
}
class ResubscribeRecipientRequest {
  static fromProto(proto) {
    let m = new ResubscribeRecipientRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    return toReturn;
  }
}
class SaveCategoryPreferencesRequest {
  static fromProto(proto) {
    let m = new SaveCategoryPreferencesRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    if (typeof this.unverifiedEmailAddress !== 'undefined') {
      toReturn['unverifiedEmailAddress'] = this.unverifiedEmailAddress;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.optedInEmailCategoryIds !== 'undefined') {
      toReturn['optedInEmailCategoryIds'] = this.optedInEmailCategoryIds;
    }
    return toReturn;
  }
}
class SendFromAuthorizedDomainRequest {
  static fromProto(proto) {
    let m = new SendFromAuthorizedDomainRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipient) {
      m.recipient = Participant.fromProto(proto.recipient);
    }
    if (proto.message) {
      m.message = WhiteLabelEmailMessage.fromProto(proto.message);
    }
    if (proto.customSender) {
      m.customSender = CustomSender.fromProto(proto.customSender);
    }
    if (proto.inboundMessageMappingOptions) {
      m.inboundMessageMappingOptions = InboundMessageMappingOptions.fromProto(proto.inboundMessageMappingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipient !== 'undefined' && this.recipient !== null) {
      toReturn['recipient'] = 'toApiJson' in this.recipient ? this.recipient.toApiJson() : this.recipient;
    }
    if (typeof this.message !== 'undefined' && this.message !== null) {
      toReturn['message'] = 'toApiJson' in this.message ? this.message.toApiJson() : this.message;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.transactional !== 'undefined') {
      toReturn['transactional'] = this.transactional;
    }
    if (typeof this.encryptContentAtRest !== 'undefined') {
      toReturn['encryptContentAtRest'] = this.encryptContentAtRest;
    }
    if (typeof this.customSender !== 'undefined' && this.customSender !== null) {
      toReturn['customSender'] = 'toApiJson' in this.customSender ? this.customSender.toApiJson() : this.customSender;
    }
    if (typeof this.inboundMessageMappingOptions !== 'undefined' && this.inboundMessageMappingOptions !== null) {
      toReturn['inboundMessageMappingOptions'] = 'toApiJson' in this.inboundMessageMappingOptions ? this.inboundMessageMappingOptions.toApiJson() : this.inboundMessageMappingOptions;
    }
    return toReturn;
  }
}
class SendFromAuthorizedDomainResponse {
  static fromProto(proto) {
    let m = new SendFromAuthorizedDomainResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    return toReturn;
  }
}
class SendGridSubUserReputation {
  static fromProto(proto) {
    let m = new SendGridSubUserReputation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.username !== 'undefined') {
      toReturn['username'] = this.username;
    }
    if (typeof this.reputationPercent !== 'undefined') {
      toReturn['reputationPercent'] = this.reputationPercent;
    }
    return toReturn;
  }
}
class SendGridTeammate {
  static fromProto(proto) {
    let m = new SendGridTeammate();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fullName !== 'undefined') {
      toReturn['fullName'] = this.fullName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.role !== 'undefined') {
      toReturn['role'] = this.role;
    }
    if (typeof this.slackUserName !== 'undefined') {
      toReturn['slackUserName'] = this.slackUserName;
    }
    if (typeof this.slackUrl !== 'undefined') {
      toReturn['slackUrl'] = this.slackUrl;
    }
    return toReturn;
  }
}
class SendRequest {
  static fromProto(proto) {
    let m = new SendRequest();
    m = Object.assign(m, proto);
    if (proto.email) {
      m.email = EmailMessage.fromProto(proto.email);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined' && this.email !== null) {
      toReturn['email'] = 'toApiJson' in this.email ? this.email.toApiJson() : this.email;
    }
    if (typeof this.espId !== 'undefined') {
      toReturn['espId'] = this.espId;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class SendResponse {
  static fromProto(proto) {
    let m = new SendResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    return toReturn;
  }
}
class SendV2Request {
  static fromProto(proto) {
    let m = new SendV2Request();
    m = Object.assign(m, proto);
    if (proto.email) {
      m.email = EmailMessageV2.fromProto(proto.email);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined' && this.email !== null) {
      toReturn['email'] = 'toApiJson' in this.email ? this.email.toApiJson() : this.email;
    }
    if (typeof this.espId !== 'undefined') {
      toReturn['espId'] = this.espId;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class SendV2Response {
  static fromProto(proto) {
    let m = new SendV2Response();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    return toReturn;
  }
}
class SendWhitelabelEmailToUserRequest {
  static fromProto(proto) {
    let m = new SendWhitelabelEmailToUserRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.recipientUser) {
      m.recipientUser = UserParticipant.fromProto(proto.recipientUser);
    }
    if (proto.message) {
      m.message = WhiteLabelEmailMessage.fromProto(proto.message);
    }
    if (proto.userParticipant) {
      m.userParticipant = UserParticipant.fromProto(proto.userParticipant);
    }
    if (proto.contactParticipant) {
      m.contactParticipant = ContactParticipant.fromProto(proto.contactParticipant);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipientUser !== 'undefined' && this.recipientUser !== null) {
      toReturn['recipientUser'] = 'toApiJson' in this.recipientUser ? this.recipientUser.toApiJson() : this.recipientUser;
    }
    if (typeof this.message !== 'undefined' && this.message !== null) {
      toReturn['message'] = 'toApiJson' in this.message ? this.message.toApiJson() : this.message;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.transactional !== 'undefined') {
      toReturn['transactional'] = this.transactional;
    }
    if (typeof this.userParticipant !== 'undefined' && this.userParticipant !== null) {
      toReturn['userParticipant'] = 'toApiJson' in this.userParticipant ? this.userParticipant.toApiJson() : this.userParticipant;
    }
    if (typeof this.contactParticipant !== 'undefined' && this.contactParticipant !== null) {
      toReturn['contactParticipant'] = 'toApiJson' in this.contactParticipant ? this.contactParticipant.toApiJson() : this.contactParticipant;
    }
    return toReturn;
  }
}
class SendWhitelabelEmailToUserResponse {
  static fromProto(proto) {
    let m = new SendWhitelabelEmailToUserResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    return toReturn;
  }
}
class SendWithCustomDomainRequest {
  static fromProto(proto) {
    let m = new SendWithCustomDomainRequest();
    m = Object.assign(m, proto);
    if (proto.email) {
      m.email = EmailWithCustomDomainMessage.fromProto(proto.email);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.email !== 'undefined' && this.email !== null) {
      toReturn['email'] = 'toApiJson' in this.email ? this.email.toApiJson() : this.email;
    }
    if (typeof this.idempotencyKey !== 'undefined') {
      toReturn['idempotencyKey'] = this.idempotencyKey;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.fallbackEmail !== 'undefined') {
      toReturn['fallbackEmail'] = this.fallbackEmail;
    }
    if (typeof this.fallbackName !== 'undefined') {
      toReturn['fallbackName'] = this.fallbackName;
    }
    if (typeof this.fallbackEspId !== 'undefined') {
      toReturn['fallbackEspId'] = this.fallbackEspId;
    }
    return toReturn;
  }
}
class SendWithCustomDomainResponse {
  static fromProto(proto) {
    let m = new SendWithCustomDomainResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emailId !== 'undefined') {
      toReturn['emailId'] = this.emailId;
    }
    if (typeof this.customDomainUsed !== 'undefined') {
      toReturn['customDomainUsed'] = this.customDomainUsed;
    }
    return toReturn;
  }
}
class Sender {
  static fromProto(proto) {
    let m = new Sender();
    m = Object.assign(m, proto);
    if (proto.type) {
      m.type = enumStringToValue(SenderType, proto.type);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.type !== 'undefined') {
      toReturn['type'] = this.type;
    }
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.appNamespace !== 'undefined') {
      toReturn['appNamespace'] = this.appNamespace;
    }
    return toReturn;
  }
}
class SenderDomain {
  static fromProto(proto) {
    let m = new SenderDomain();
    m = Object.assign(m, proto);
    if (proto.targets) {
      m.targets = GetPendingEmailDomainTargetCNameRecords.fromProto(proto.targets);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sendFromDomain !== 'undefined') {
      toReturn['sendFromDomain'] = this.sendFromDomain;
    }
    if (typeof this.targetSpf !== 'undefined') {
      toReturn['targetSpf'] = this.targetSpf;
    }
    if (typeof this.currentSpf !== 'undefined') {
      toReturn['currentSpf'] = this.currentSpf;
    }
    if (typeof this.targets !== 'undefined' && this.targets !== null) {
      toReturn['targets'] = 'toApiJson' in this.targets ? this.targets.toApiJson() : this.targets;
    }
    if (typeof this.isPrimary !== 'undefined') {
      toReturn['isPrimary'] = this.isPrimary;
    }
    return toReturn;
  }
}
class SetEmailQueuesStatusRequest {
  static fromProto(proto) {
    let m = new SetEmailQueuesStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.running !== 'undefined') {
      toReturn['running'] = this.running;
    }
    return toReturn;
  }
}
class Status {
  static fromProto(proto) {
    let m = new Status();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    if (proto.status) {
      m.status = enumStringToValue(RecipientStatusEnum, proto.status);
    }
    if (proto.infractionCount) {
      m.infractionCount = parseInt(proto.infractionCount, 10);
    }
    if (proto.bounceExpiry) {
      m.bounceExpiry = new Date(proto.bounceExpiry);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.infractionCount !== 'undefined') {
      toReturn['infractionCount'] = this.infractionCount;
    }
    if (typeof this.bounceExpiry !== 'undefined' && this.bounceExpiry !== null) {
      toReturn['bounceExpiry'] = 'toApiJson' in this.bounceExpiry ? this.bounceExpiry.toApiJson() : this.bounceExpiry;
    }
    return toReturn;
  }
}
class UnbounceRecipientRequest {
  static fromProto(proto) {
    let m = new UnbounceRecipientRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = BounceSender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    if (typeof this.recipientEmail !== 'undefined') {
      toReturn['recipientEmail'] = this.recipientEmail;
    }
    return toReturn;
  }
}
class UpsertPartnerEmailQuotaRequest {
  static fromProto(proto) {
    let m = new UpsertPartnerEmailQuotaRequest();
    m = Object.assign(m, proto);
    if (proto.dailyQuota) {
      m.dailyQuota = parseInt(proto.dailyQuota, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.dailyQuota !== 'undefined') {
      toReturn['dailyQuota'] = this.dailyQuota;
    }
    return toReturn;
  }
}
class VerifyDefaultDomainMismatch {
  static fromProto(proto) {
    let m = new VerifyDefaultDomainMismatch();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dnsRecordType !== 'undefined') {
      toReturn['dnsRecordType'] = this.dnsRecordType;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.expectedValue !== 'undefined') {
      toReturn['expectedValue'] = this.expectedValue;
    }
    if (typeof this.actualValue !== 'undefined') {
      toReturn['actualValue'] = this.actualValue;
    }
    if (typeof this.matchedPrefix !== 'undefined') {
      toReturn['matchedPrefix'] = this.matchedPrefix;
    }
    if (typeof this.matchedSuffix !== 'undefined') {
      toReturn['matchedSuffix'] = this.matchedSuffix;
    }
    return toReturn;
  }
}
class VerifyDefaultDomainRequest {
  static fromProto(proto) {
    let m = new VerifyDefaultDomainRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class VerifyDefaultDomainResponse {
  static fromProto(proto) {
    let m = new VerifyDefaultDomainResponse();
    m = Object.assign(m, proto);
    if (proto.mismatches) {
      m.mismatches = proto.mismatches.map(VerifyDefaultDomainMismatch.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.allRecordsMatch !== 'undefined') {
      toReturn['allRecordsMatch'] = this.allRecordsMatch;
    }
    if (typeof this.mismatches !== 'undefined' && this.mismatches !== null) {
      toReturn['mismatches'] = 'toApiJson' in this.mismatches ? this.mismatches.toApiJson() : this.mismatches;
    }
    return toReturn;
  }
}
class VerifyEmailDomainDMARCRequest {
  static fromProto(proto) {
    let m = new VerifyEmailDomainDMARCRequest();
    m = Object.assign(m, proto);
    if (proto.sender) {
      m.sender = Sender.fromProto(proto.sender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sender !== 'undefined' && this.sender !== null) {
      toReturn['sender'] = 'toApiJson' in this.sender ? this.sender.toApiJson() : this.sender;
    }
    return toReturn;
  }
}
class VerifyEmailDomainDMARCResponse {
  static fromProto(proto) {
    let m = new VerifyEmailDomainDMARCResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dmarcPass !== 'undefined') {
      toReturn['dmarcPass'] = this.dmarcPass;
    }
    if (typeof this.dmarcRecord !== 'undefined') {
      toReturn['dmarcRecord'] = this.dmarcRecord;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class VerifyEmailDomainRequest {
  static fromProto(proto) {
    let m = new VerifyEmailDomainRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.applicationId !== 'undefined') {
      toReturn['applicationId'] = this.applicationId;
    }
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    return toReturn;
  }
}
class VerifyPendingEmailDomainMismatch {
  static fromProto(proto) {
    let m = new VerifyPendingEmailDomainMismatch();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dnsRecordType !== 'undefined') {
      toReturn['dnsRecordType'] = this.dnsRecordType;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.expectedValue !== 'undefined') {
      toReturn['expectedValue'] = this.expectedValue;
    }
    if (typeof this.actualValue !== 'undefined') {
      toReturn['actualValue'] = this.actualValue;
    }
    if (typeof this.matchedPrefix !== 'undefined') {
      toReturn['matchedPrefix'] = this.matchedPrefix;
    }
    if (typeof this.matchedSuffix !== 'undefined') {
      toReturn['matchedSuffix'] = this.matchedSuffix;
    }
    return toReturn;
  }
}
class VerifyPendingEmailDomainRequest {
  static fromProto(proto) {
    let m = new VerifyPendingEmailDomainRequest();
    m = Object.assign(m, proto);
    if (proto.senderType) {
      m.senderType = enumStringToValue(SenderType, proto.senderType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.senderType !== 'undefined') {
      toReturn['senderType'] = this.senderType;
    }
    if (typeof this.senderId !== 'undefined') {
      toReturn['senderId'] = this.senderId;
    }
    return toReturn;
  }
}
class VerifyPendingEmailDomainResponse {
  static fromProto(proto) {
    let m = new VerifyPendingEmailDomainResponse();
    m = Object.assign(m, proto);
    if (proto.mismatches) {
      m.mismatches = proto.mismatches.map(VerifyPendingEmailDomainMismatch.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.allRecordsMatch !== 'undefined') {
      toReturn['allRecordsMatch'] = this.allRecordsMatch;
    }
    if (typeof this.mismatches !== 'undefined' && this.mismatches !== null) {
      toReturn['mismatches'] = 'toApiJson' in this.mismatches ? this.mismatches.toApiJson() : this.mismatches;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'email-api.vendasta-local.com',
  'test': '',
  'demo': 'email-api-demo.apigateway.co',
  'prod': 'email-api-prod.apigateway.co',
  'production': 'email-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EmailApiService = /*#__PURE__*/(() => {
  class EmailApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    send(r) {
      const request = r.toApiJson ? r : new SendRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/Send", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendResponse.fromProto(resp)));
    }
    sendWithCustomDomain(r) {
      const request = r.toApiJson ? r : new SendWithCustomDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/SendWithCustomDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendWithCustomDomainResponse.fromProto(resp)));
    }
    sendV2(r) {
      const request = r.toApiJson ? r : new SendV2Request(r);
      return this.http.post(this._host + "/email.v1.EmailService/SendV2", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendV2Response.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListEmailsRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEmailsResponse.fromProto(resp)));
    }
    getEmailQueuesStatus(r) {
      const request = r.toApiJson ? r : new GetEmailQueuesStatusRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/GetEmailQueuesStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmailQueuesStatusResponse.fromProto(resp)));
    }
    setEmailQueuesStatus(r) {
      const request = r.toApiJson ? r : new SetEmailQueuesStatusRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/SetEmailQueuesStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getEmailDomain(r) {
      const request = r.toApiJson ? r : new GetEmailDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/GetEmailDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmailDomainResponse.fromProto(resp)));
    }
    createEmailDomain(r) {
      const request = r.toApiJson ? r : new CreateEmailDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/CreateEmailDomain", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    createEmailDomainWithSendAs(r) {
      const request = r.toApiJson ? r : new CreateEmailDomainWithSendAsRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/CreateEmailDomainWithSendAs", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    verifyEmailDomain(r) {
      const request = r.toApiJson ? r : new VerifyEmailDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/VerifyEmailDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmailDomainResponse.fromProto(resp)));
    }
    deleteEmailDomain(r) {
      const request = r.toApiJson ? r : new DeleteEmailDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/DeleteEmailDomain", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    changeEmailDomain(r) {
      const request = r.toApiJson ? r : new ChangeEmailDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/ChangeEmailDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => ChangeEmailDomainResponse.fromProto(resp)));
    }
    getPendingEmailDomain(r) {
      const request = r.toApiJson ? r : new GetPendingEmailDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/GetPendingEmailDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPendingEmailDomainResponse.fromProto(resp)));
    }
    verifyPendingEmailDomain(r) {
      const request = r.toApiJson ? r : new VerifyPendingEmailDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/VerifyPendingEmailDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => VerifyPendingEmailDomainResponse.fromProto(resp)));
    }
    deletePendingEmailDomain(r) {
      const request = r.toApiJson ? r : new DeletePendingEmailDomainRequest(r);
      return this.http.post(this._host + "/email.v1.EmailService/DeletePendingEmailDomain", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  EmailApiService.ɵfac = function EmailApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailApiService)();
  };
  EmailApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailApiService,
    factory: EmailApiService.ɵfac,
    providedIn: 'root'
  });
  return EmailApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AdminApiService = /*#__PURE__*/(() => {
  class AdminApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    setEmailQueuesStatus(r) {
      const request = r.toApiJson ? r : new AdminSetEmailQueuesStatusRequest(r);
      return this.http.post(this._host + "/email.v1.Admin/SetEmailQueuesStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    redirectEmail(r) {
      const request = r.toApiJson ? r : new RedirectEmailRequest(r);
      return this.http.post(this._host + "/email.v1.Admin/RedirectEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => RedirectEmailResponse.fromProto(resp)));
    }
    resubscribeRecipient(r) {
      const request = r.toApiJson ? r : new ResubscribeRecipientRequest(r);
      return this.http.post(this._host + "/email.v1.Admin/ResubscribeRecipient", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getUnsubscribedRecipient(r) {
      const request = r.toApiJson ? r : new GetUnsubscribedRecipientRequest(r);
      return this.http.post(this._host + "/email.v1.Admin/GetUnsubscribedRecipient", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUnsubscribedRecipientResponse.fromProto(resp)));
    }
    initiateEmailDomainRollback(r) {
      const request = r.toApiJson ? r : new InitiateEmailDomainRollbackRequest(r);
      return this.http.post(this._host + "/email.v1.Admin/InitiateEmailDomainRollback", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    initiateEmailDomainRectify(r) {
      const request = r.toApiJson ? r : new InitiateEmailDomainRectifyRequest(r);
      return this.http.post(this._host + "/email.v1.Admin/InitiateEmailDomainRectify", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getBouncedRecipient(r) {
      const request = r.toApiJson ? r : new GetBouncedRecipientRequest(r);
      return this.http.post(this._host + "/email.v1.Admin/GetBouncedRecipient", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBouncedRecipientResponse.fromProto(resp)));
    }
    unbounceRecipient(r) {
      const request = r.toApiJson ? r : new UnbounceRecipientRequest(r);
      return this.http.post(this._host + "/email.v1.Admin/UnbounceRecipient", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AdminApiService.ɵfac = function AdminApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AdminApiService)();
  };
  AdminApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AdminApiService,
    factory: AdminApiService.ɵfac,
    providedIn: 'root'
  });
  return AdminApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AdminService = /*#__PURE__*/(() => {
  class AdminService {
    constructor(api) {
      this.api = api;
    }
    setEmailQueuesStatus(running) {
      let statusEnum = EmailQueueStatus.EMAIL_QUEUE_STATUS_RUNNING;
      if (!running) {
        statusEnum = EmailQueueStatus.EMAIL_QUEUE_STATUS_DISABLED;
      }
      const req = new AdminSetEmailQueuesStatusRequest({
        status: statusEnum
      });
      return this.api.setEmailQueuesStatus(req);
    }
    getUnsubscribedRecipientForPartner(partnerID, recipientEmail) {
      const req = new GetUnsubscribedRecipientRequest({
        senderId: partnerID,
        senderType: SenderType.SENDER_TYPE_PARTNER,
        recipientEmail: recipientEmail
      });
      return this.api.getUnsubscribedRecipient(req);
    }
    getUnsubscribedRecipientForBusiness(recipientEmail) {
      const req = new GetUnsubscribedRecipientRequest({
        senderType: SenderType.SENDER_TYPE_BUSINESS,
        recipientEmail: recipientEmail
      });
      return this.api.getUnsubscribedRecipient(req);
    }
    getUnsubscribedRecipientForProduct(recipientEmail) {
      const req = new GetUnsubscribedRecipientRequest({
        senderType: SenderType.SENDER_TYPE_PARTNER,
        recipientEmail: recipientEmail
      });
      return this.api.getUnsubscribedRecipient(req);
    }
    getBouncedRecipient(sender, recipientEmail) {
      const req = new GetBouncedRecipientRequest({
        sender: sender,
        recipientEmail: recipientEmail
      });
      return this.api.getBouncedRecipient(req);
    }
    unbounceRecipient(sender, recipientEmail) {
      const req = new UnbounceRecipientRequest({
        sender: sender,
        recipientEmail: recipientEmail
      });
      return this.api.unbounceRecipient(req);
    }
    resubscribeRecipientForPartner(partnerID, recipientEmail) {
      const req = new ResubscribeRecipientRequest({
        senderId: partnerID,
        senderType: SenderType.SENDER_TYPE_PARTNER,
        recipientEmail: recipientEmail
      });
      return this.api.resubscribeRecipient(req);
    }
    resubscribeRecipientForBusiness(recipientEmail) {
      const req = new ResubscribeRecipientRequest({
        senderType: SenderType.SENDER_TYPE_BUSINESS,
        recipientEmail: recipientEmail
      });
      return this.api.resubscribeRecipient(req);
    }
    resubscribeRecipientForProduct(recipientEmail) {
      const req = new ResubscribeRecipientRequest({
        senderType: SenderType.SENDER_TYPE_PARTNER,
        recipientEmail: recipientEmail
      });
      return this.api.resubscribeRecipient(req);
    }
    redirectEmail(emailID, newRecipientEmailAddress, authCheckOnly, includeContent, includeAttributes) {
      const req = new RedirectEmailRequest({
        emailId: emailID,
        newRecipientEmailAddress: newRecipientEmailAddress,
        authCheckOnly: authCheckOnly,
        includeContent: includeContent,
        includeAttributes: includeAttributes
      });
      return this.api.redirectEmail(req);
    }
  }
  AdminService.ɵfac = function AdminService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AdminService)(i0.ɵɵinject(AdminApiService));
  };
  AdminService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AdminService,
    factory: AdminService.ɵfac,
    providedIn: 'root'
  });
  return AdminService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmailService = /*#__PURE__*/(() => {
  class EmailService {
    constructor(api, admin) {
      this.api = api;
      this.admin = admin;
    }
    createEmailDomain(partnerId, applicationId, businessId, domain, userId = '') {
      const req = CreateEmailDomainRequest.fromProto({
        partnerId: partnerId,
        applicationId: applicationId,
        businessId: businessId,
        domain: domain,
        userId: userId
      });
      return this.api.createEmailDomain(req);
    }
    createEmailDomainWithSendAs(partnerId, applicationId, businessId, domain, sendAsEmail, sendAsName) {
      const req = CreateEmailDomainWithSendAsRequest.fromProto({
        partnerId: partnerId,
        applicationId: applicationId,
        businessId: businessId,
        domain: domain,
        sendAsEmail: sendAsEmail,
        sendAsName: sendAsName
      });
      return this.api.createEmailDomainWithSendAs(req);
    }
    getEmailDomain(partnerId, applicationId, businessId) {
      const req = GetEmailDomainRequest.fromProto({
        partnerId: partnerId,
        applicationId: applicationId,
        businessId: businessId
      });
      return this.api.getEmailDomain(req).pipe(map(r => r.domain));
    }
    verifyEmailDomain(partnerId, applicationId, businessId) {
      const req = VerifyEmailDomainRequest.fromProto({
        partnerId: partnerId,
        applicationId: applicationId,
        businessId: businessId
      });
      return this.api.verifyEmailDomain(req).pipe(map(r => r.domain));
    }
    listEmails(searchTerm, filters, pagingOptions) {
      return this.api.list({
        searchTerm: searchTerm,
        pagingOptions: pagingOptions,
        filters: filters
      });
    }
    getEmailQueuesStatus() {
      const req = GetEmailQueuesStatusRequest.fromProto({});
      return this.api.getEmailQueuesStatus(req).pipe(map(r => r.running));
    }
    /**
     * @deprecated Use AdminService.setEmailQueuesStatus
     */
    setEmailQueuesStatus(running) {
      return this.admin.setEmailQueuesStatus(running);
    }
  }
  EmailService.ɵfac = function EmailService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailService)(i0.ɵɵinject(EmailApiService), i0.ɵɵinject(AdminService));
  };
  EmailService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailService,
    factory: EmailService.ɵfac,
    providedIn: 'root'
  });
  return EmailService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EmailEventApiService = /*#__PURE__*/(() => {
  class EmailEventApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListEmailEventsRequest(r);
      return this.http.post(this._host + "/email.v1.EmailEventService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEmailEventsResponse.fromProto(resp)));
    }
    getMultiEmailRollups(r) {
      const request = r.toApiJson ? r : new GetMultiEmailRollupsRequest(r);
      return this.http.post(this._host + "/email.v1.EmailEventService/GetMultiEmailRollups", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiEmailRollupsResponse.fromProto(resp)));
    }
    listForAttributes(r) {
      const request = r.toApiJson ? r : new ListEventsForAttributesRequest(r);
      return this.http.post(this._host + "/email.v1.EmailEventService/ListForAttributes", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEventsForAttributesResponse.fromProto(resp)));
    }
    getAttributeEventStats(r) {
      const request = r.toApiJson ? r : new GetAttributeEventStatsRequest(r);
      return this.http.post(this._host + "/email.v1.EmailEventService/GetAttributeEventStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAttributeEventStatsResponse.fromProto(resp)));
    }
    getAttributeEventLinkStats(r) {
      const request = r.toApiJson ? r : new GetAttributeEventLinkStatsRequest(r);
      return this.http.post(this._host + "/email.v1.EmailEventService/GetAttributeEventLinkStats", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAttributeEventLinkStatsResponse.fromProto(resp)));
    }
    listLinkClickActivityForAttribute(r) {
      const request = r.toApiJson ? r : new ListLinkClickActivityForAttributeRequest(r);
      return this.http.post(this._host + "/email.v1.EmailEventService/ListLinkClickActivityForAttribute", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListLinkClickActivityForAttributeResponse.fromProto(resp)));
    }
    exportAttributeEventClickStats(r) {
      const request = r.toApiJson ? r : new ExportAttributeEventClickStatsRequest(r);
      return this.http.post(this._host + "/email.v1.EmailEventService/ExportAttributeEventClickStats", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  EmailEventApiService.ɵfac = function EmailEventApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailEventApiService)();
  };
  EmailEventApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailEventApiService,
    factory: EmailEventApiService.ɵfac,
    providedIn: 'root'
  });
  return EmailEventApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let BlocksApiService = /*#__PURE__*/(() => {
  class BlocksApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createBlock(r) {
      const request = r.toApiJson ? r : new CreateBlockRequest(r);
      return this.http.post(this._host + "/email.v1.Blocks/CreateBlock", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateBlockResponse.fromProto(resp)));
    }
    getBlock(r) {
      const request = r.toApiJson ? r : new GetBlockRequest(r);
      return this.http.post(this._host + "/email.v1.Blocks/GetBlock", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBlockResponse.fromProto(resp)));
    }
    deleteBlock(r) {
      const request = r.toApiJson ? r : new DeleteBlockRequest(r);
      return this.http.post(this._host + "/email.v1.Blocks/DeleteBlock", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  BlocksApiService.ɵfac = function BlocksApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BlocksApiService)();
  };
  BlocksApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BlocksApiService,
    factory: BlocksApiService.ɵfac,
    providedIn: 'root'
  });
  return BlocksApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let DisposableEmailApiService = /*#__PURE__*/(() => {
  class DisposableEmailApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    checkDisposableEmail(r) {
      const request = r.toApiJson ? r : new CheckDisposableEmailRequest(r);
      return this.http.post(this._host + "/email.v1.DisposableEmail/CheckDisposableEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => CheckDisposableEmailResponse.fromProto(resp)));
    }
  }
  DisposableEmailApiService.ɵfac = function DisposableEmailApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DisposableEmailApiService)();
  };
  DisposableEmailApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DisposableEmailApiService,
    factory: DisposableEmailApiService.ɵfac,
    providedIn: 'root'
  });
  return DisposableEmailApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let DomainApiService = /*#__PURE__*/(() => {
  class DomainApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createPendingDomain(r) {
      const request = r.toApiJson ? r : new CreatePendingDomainRequest(r);
      return this.http.post(this._host + "/email.v1.Domain/CreatePendingDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPendingEmailDomainResponse.fromProto(resp)));
    }
    listAllDomains(r) {
      const request = r.toApiJson ? r : new ListAllDomainsRequest(r);
      return this.http.post(this._host + "/email.v1.Domain/ListAllDomains", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllDomainsResponse.fromProto(resp)));
    }
    getDefaultDomain(r) {
      const request = r.toApiJson ? r : new GetDefaultDomainRequest(r);
      return this.http.post(this._host + "/email.v1.Domain/GetDefaultDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetDefaultDomainResponse.fromProto(resp)));
    }
    verifyDefaultDomain(r) {
      const request = r.toApiJson ? r : new VerifyDefaultDomainRequest(r);
      return this.http.post(this._host + "/email.v1.Domain/VerifyDefaultDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => VerifyDefaultDomainResponse.fromProto(resp)));
    }
    verifyEmailDomainDmarc(r) {
      const request = r.toApiJson ? r : new VerifyEmailDomainDMARCRequest(r);
      return this.http.post(this._host + "/email.v1.Domain/VerifyEmailDomainDMARC", request.toApiJson(), this.apiOptions()).pipe(map(resp => VerifyEmailDomainDMARCResponse.fromProto(resp)));
    }
  }
  DomainApiService.ɵfac = function DomainApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DomainApiService)();
  };
  DomainApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DomainApiService,
    factory: DomainApiService.ɵfac,
    providedIn: 'root'
  });
  return DomainApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EmailClientApiService = /*#__PURE__*/(() => {
  class EmailClientApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    resubscribeRecipientFromUnsubscribeLink(r) {
      const request = r.toApiJson ? r : new ResubscribeRecipientFromUnsubscribeLinkRequest(r);
      return this.http.post(this._host + "/email.v1.EmailClient/ResubscribeRecipientFromUnsubscribeLink", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  EmailClientApiService.ɵfac = function EmailClientApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailClientApiService)();
  };
  EmailClientApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailClientApiService,
    factory: EmailClientApiService.ɵfac,
    providedIn: 'root'
  });
  return EmailClientApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let InboundMessageMappingApiService = /*#__PURE__*/(() => {
  class InboundMessageMappingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createInboundMessageMapping(r) {
      const request = r.toApiJson ? r : new CreateInboundMessageMappingRequest(r);
      return this.http.post(this._host + "/email.v1.InboundMessageMappingService/CreateInboundMessageMapping", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateInboundMessageMappingResponse.fromProto(resp)));
    }
    getInboundMessageMapping(r) {
      const request = r.toApiJson ? r : new GetInboundMessageMappingRequest(r);
      return this.http.post(this._host + "/email.v1.InboundMessageMappingService/GetInboundMessageMapping", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetInboundMessageMappingResponse.fromProto(resp)));
    }
    getReplyEmail(r) {
      const request = r.toApiJson ? r : new GetReplyEmailRequest(r);
      return this.http.post(this._host + "/email.v1.InboundMessageMappingService/GetReplyEmail", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReplyEmailResponse.fromProto(resp)));
    }
  }
  InboundMessageMappingApiService.ɵfac = function InboundMessageMappingApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InboundMessageMappingApiService)();
  };
  InboundMessageMappingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InboundMessageMappingApiService,
    factory: InboundMessageMappingApiService.ɵfac,
    providedIn: 'root'
  });
  return InboundMessageMappingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let InboundMessageApiService = /*#__PURE__*/(() => {
  class InboundMessageApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getInboundMessage(r) {
      const request = r.toApiJson ? r : new GetInboundMessageRequest(r);
      return this.http.post(this._host + "/email.v1.InboundMessageService/GetInboundMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetInboundMessageResponse.fromProto(resp)));
    }
  }
  InboundMessageApiService.ɵfac = function InboundMessageApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InboundMessageApiService)();
  };
  InboundMessageApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InboundMessageApiService,
    factory: InboundMessageApiService.ɵfac,
    providedIn: 'root'
  });
  return InboundMessageApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let MessageApiService = /*#__PURE__*/(() => {
  class MessageApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMessage(r) {
      const request = r.toApiJson ? r : new GetMessageRequest(r);
      return this.http.post(this._host + "/email.v1.Message/GetMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMessageResponse.fromProto(resp)));
    }
    getMultiMessage(r) {
      const request = r.toApiJson ? r : new GetMultiMessageRequest(r);
      return this.http.post(this._host + "/email.v1.Message/GetMultiMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiMessageResponse.fromProto(resp)));
    }
  }
  MessageApiService.ɵfac = function MessageApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MessageApiService)();
  };
  MessageApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MessageApiService,
    factory: MessageApiService.ɵfac,
    providedIn: 'root'
  });
  return MessageApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PartnerEmailQuotaApiService = /*#__PURE__*/(() => {
  class PartnerEmailQuotaApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    upsert(r) {
      const request = r.toApiJson ? r : new UpsertPartnerEmailQuotaRequest(r);
      return this.http.post(this._host + "/email.v1.PartnerEmailQuotaService/Upsert", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkUpsert(r) {
      const request = r.toApiJson ? r : new BulkUpsertPartnerEmailQuotaRequest(r);
      return this.http.post(this._host + "/email.v1.PartnerEmailQuotaService/BulkUpsert", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeletePartnerEmailQuotaRequest(r);
      return this.http.post(this._host + "/email.v1.PartnerEmailQuotaService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiPartnerEmailQuotaRequest(r);
      return this.http.post(this._host + "/email.v1.PartnerEmailQuotaService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiPartnerEmailQuotaResponse.fromProto(resp)));
    }
  }
  PartnerEmailQuotaApiService.ɵfac = function PartnerEmailQuotaApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PartnerEmailQuotaApiService)();
  };
  PartnerEmailQuotaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PartnerEmailQuotaApiService,
    factory: PartnerEmailQuotaApiService.ɵfac,
    providedIn: 'root'
  });
  return PartnerEmailQuotaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let PreferencesApiService = /*#__PURE__*/(() => {
  class PreferencesApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getCategories(r) {
      const request = r.toApiJson ? r : new GetCategoriesRequest(r);
      return this.http.post(this._host + "/email.v1.Preferences/GetCategories", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoriesResponse.fromProto(resp)));
    }
    getCategoryPreferences(r) {
      const request = r.toApiJson ? r : new GetCategoryPreferencesRequest(r);
      return this.http.post(this._host + "/email.v1.Preferences/GetCategoryPreferences", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCategoryPreferencesResponse.fromProto(resp)));
    }
    saveCategoryPreferences(r) {
      const request = r.toApiJson ? r : new SaveCategoryPreferencesRequest(r);
      return this.http.post(this._host + "/email.v1.Preferences/SaveCategoryPreferences", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getUnsubscribeLink(r) {
      const request = r.toApiJson ? r : new GetUnsubscribeLinkRequest(r);
      return this.http.post(this._host + "/email.v1.Preferences/GetUnsubscribeLink", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUnsubscribeLinkResponse.fromProto(resp)));
    }
  }
  PreferencesApiService.ɵfac = function PreferencesApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PreferencesApiService)();
  };
  PreferencesApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PreferencesApiService,
    factory: PreferencesApiService.ɵfac,
    providedIn: 'root'
  });
  return PreferencesApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let RecipientStatusApiService = /*#__PURE__*/(() => {
  class RecipientStatusApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    resetRecipientStatus(r) {
      const request = r.toApiJson ? r : new ResetRecipientStatusRequest(r);
      return this.http.post(this._host + "/email.v1.RecipientStatus/ResetRecipientStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    batchSearchRecipientStatus(r) {
      const request = r.toApiJson ? r : new BatchSearchRecipientStatusRequest(r);
      return this.http.post(this._host + "/email.v1.RecipientStatus/BatchSearchRecipientStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => BatchSearchRecipientStatusResponse.fromProto(resp)));
    }
  }
  RecipientStatusApiService.ɵfac = function RecipientStatusApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecipientStatusApiService)();
  };
  RecipientStatusApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecipientStatusApiService,
    factory: RecipientStatusApiService.ɵfac,
    providedIn: 'root'
  });
  return RecipientStatusApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SendApiService = /*#__PURE__*/(() => {
  class SendApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    sendWhitelabelEmailToUser(r) {
      const request = r.toApiJson ? r : new SendWhitelabelEmailToUserRequest(r);
      return this.http.post(this._host + "/email.v1.Send/SendWhitelabelEmailToUser", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendWhitelabelEmailToUserResponse.fromProto(resp)));
    }
    sendFromAuthorizedDomain(r) {
      const request = r.toApiJson ? r : new SendFromAuthorizedDomainRequest(r);
      return this.http.post(this._host + "/email.v1.Send/SendFromAuthorizedDomain", request.toApiJson(), this.apiOptions()).pipe(map(resp => SendFromAuthorizedDomainResponse.fromProto(resp)));
    }
  }
  SendApiService.ɵfac = function SendApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SendApiService)();
  };
  SendApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SendApiService,
    factory: SendApiService.ɵfac,
    providedIn: 'root'
  });
  return SendApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SendGridApiService = /*#__PURE__*/(() => {
  class SendGridApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listSendGridTeammates(r) {
      const request = r.toApiJson ? r : new ListSendGridTeammatesRequest(r);
      return this.http.post(this._host + "/email.v1.SendGridService/ListSendGridTeammates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSendGridTeammatesResponse.fromProto(resp)));
    }
    listSendGridSubUserReputations(r) {
      const request = r.toApiJson ? r : new ListSendGridSubUserReputationsRequest(r);
      return this.http.post(this._host + "/email.v1.SendGridService/ListSendGridSubUserReputations", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSendGridSubUserReputationsResponse.fromProto(resp)));
    }
  }
  SendGridApiService.ɵfac = function SendGridApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SendGridApiService)();
  };
  SendGridApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SendGridApiService,
    factory: SendGridApiService.ɵfac,
    providedIn: 'root'
  });
  return SendGridApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SendersApiService = /*#__PURE__*/(() => {
  class SendersApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getSenderInfo(r) {
      const request = r.toApiJson ? r : new GetSenderInfoRequest(r);
      return this.http.post(this._host + "/email.v1.Senders/GetSenderInfo", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetSenderInfoResponse.fromProto(resp)));
    }
    quarantineSender(r) {
      const request = r.toApiJson ? r : new QuarantineSenderRequest(r);
      return this.http.post(this._host + "/email.v1.Senders/QuarantineSender", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SendersApiService.ɵfac = function SendersApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SendersApiService)();
  };
  SendersApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SendersApiService,
    factory: SendersApiService.ɵfac,
    providedIn: 'root'
  });
  return SendersApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SubUserApiService = /*#__PURE__*/(() => {
  class SubUserApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    initializeSubUser(r) {
      const request = r.toApiJson ? r : new InitializeSubUserRequest(r);
      return this.http.post(this._host + "/email.v1.SubUser/InitializeSubUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteSubUser(r) {
      const request = r.toApiJson ? r : new DeleteSubUserRequest(r);
      return this.http.post(this._host + "/email.v1.SubUser/DeleteSubUser", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SubUserApiService.ɵfac = function SubUserApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SubUserApiService)();
  };
  SubUserApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SubUserApiService,
    factory: SubUserApiService.ɵfac,
    providedIn: 'root'
  });
  return SubUserApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let EmailEventService = /*#__PURE__*/(() => {
  class EmailEventService {
    constructor(api) {
      this.api = api;
    }
    /*
      @params:
        - buckets: a list or names with an key-value pair to build aggregations on. The length of the response
        will be the same length as buckets. The key-value is for an additional filter term to use only for a specific
        aggregation.
        - dateRange: the range of dates to collect aggregations for.
        - partnerId: the partner to filter all aggregations by
        - marketId: the market to filter the aggregations by.
        - notificationTypes: the notification types to filter the aggregations by.
        - eventTypes: the event types to filter the aggregations by
      @returns: an observable containing a list of buckets that correspond  have a name, corresponding to the name passed in to
        each bucket object in the request
      @throws: an observable of a HttpErrorResponse if the client is unable to fetch the data
    */
    getEventRollups(buckets, dateRange, partnerId, marketId, notificationTypes, eventTypes) {
      if (!buckets || !buckets.length) {
        throw new HttpErrorResponse({
          status: 409,
          statusText: '1 or more buckets must be passed in'
        });
      }
      const req = new GetMultiEmailRollupsRequest({
        buckets: buckets,
        filter: new EmailEventFilter({
          dateRange: dateRange,
          partnerId: partnerId,
          marketId: marketId,
          notificationTypes: notificationTypes,
          eventTypes: eventTypes
        })
      });
      return this.api.getMultiEmailRollups(req).pipe(map(resp => (resp || {
        emailRollups: null
      }).emailRollups));
    }
    listEvents(emailId, pagingOptions, partnerId, businessId) {
      const filters = new ListEmailEventsRequestListEmailEventsFilters({
        emailId: emailId,
        partnerId: partnerId,
        businessId: businessId
      });
      return this.api.list({
        filters,
        pagingOptions
      });
    }
    getAttributeEventStats(sender, attribute) {
      return this.api.getAttributeEventStats({
        sender: sender,
        attribute: attribute
      });
    }
    getAttributeEventLinkStats(sender, attribute) {
      return this.api.getAttributeEventLinkStats({
        sender: sender,
        attribute: attribute
      });
    }
    listEventsForAttribute(sender, attribute, eventTypes, cursor, pageSize) {
      return this.api.listForAttributes({
        sender: sender,
        attribute: attribute,
        eventTypes: eventTypes,
        cursor: cursor,
        pageSize: pageSize
      });
    }
    listLinkClickActivityForAttribute(sender, attribute, normalizedURL, cursor, pageSize) {
      return this.api.listLinkClickActivityForAttribute({
        sender: sender,
        attribute: attribute,
        normalizedUrl: normalizedURL,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      });
    }
    exportAttributeEventClickStats(sender, attribute, normalizedUrl, userId) {
      return this.api.exportAttributeEventClickStats({
        sender: sender,
        attribute: attribute,
        normalizedUrl: normalizedUrl,
        userId: userId
      });
    }
  }
  EmailEventService.ɵfac = function EmailEventService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailEventService)(i0.ɵɵinject(EmailEventApiService));
  };
  EmailEventService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailEventService,
    factory: EmailEventService.ɵfac,
    providedIn: 'root'
  });
  return EmailEventService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SendgridSubUsersService = /*#__PURE__*/(() => {
  class SendgridSubUsersService {
    constructor(api) {
      this.api = api;
    }
    listSubUserReputations(pageSize = 10, cursor) {
      const req = {
        pageSize: pageSize,
        cursor: cursor
      };
      return this.api.listSendGridSubUserReputations(req);
    }
  }
  SendgridSubUsersService.ɵfac = function SendgridSubUsersService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SendgridSubUsersService)(i0.ɵɵinject(SendGridApiService));
  };
  SendgridSubUsersService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SendgridSubUsersService,
    factory: SendgridSubUsersService.ɵfac,
    providedIn: 'root'
  });
  return SendgridSubUsersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SendgridTeammatesService = /*#__PURE__*/(() => {
  class SendgridTeammatesService {
    constructor(api) {
      this.api = api;
    }
    list() {
      const req = {};
      return this.api.listSendGridTeammates(req);
    }
  }
  SendgridTeammatesService.ɵfac = function SendgridTeammatesService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SendgridTeammatesService)(i0.ɵɵinject(SendGridApiService));
  };
  SendgridTeammatesService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SendgridTeammatesService,
    factory: SendgridTeammatesService.ɵfac,
    providedIn: 'root'
  });
  return SendgridTeammatesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DomainService = /*#__PURE__*/(() => {
  class DomainService {
    constructor(api, domain) {
      this.api = api;
      this.domain = domain;
    }
    delete(partnerId, appId, businessId) {
      const req = {
        partnerId: partnerId,
        applicationId: appId,
        businessId: businessId
      };
      const observable = this.api.deleteEmailDomain(req).pipe(mapTo(null), shareReplay(1));
      observable.subscribe();
      return observable;
    }
    /**
     * Requests the partner's domain and send-from address to be changed to the
     * provided values.
     * @param partnerID The Partner ID
     * @param newDomain The domain for sending emails (e.g. The "example.com" in mail@example.com)
     * @param newEmailUsername The username for sending emails (e.g. The "mail" in mail@example.com)
     * @param appId [optional/soon-to-be-deprecated] The application ID to change
     * @param replyTo [optional] A reply-to email that can be included on emails
     * the domain for. Generally leave blank unless you know what you're doing.
     */
    changeForPartner(partnerID, newDomain, newEmailUsername, appId, replyTo, newSendFromName) {
      return this.changeForSender(SenderType.SENDER_TYPE_PARTNER, partnerID, newDomain, newEmailUsername, replyTo, newSendFromName);
    }
    /**
     * Requests the sender's domain and send-from address to be changed to the
     * provided values.
     * @param senderType The Sender type (e.g. partner or business)
     * @param senderID The Sender ID (e.g. partner ID or account group ID)
     * @param newDomain The domain for sending emails (e.g. The "example.com" in mail@example.com)
     * @param newEmailUsername The username for sending emails (e.g. The "mail" in mail@example.com)
     * @param replyTo [optional] A reply-to email that can be included on emails
     * the domain for. Generally leave blank unless you know what you're doing.
     */
    changeForSender(senderType, senderID, newDomain, newEmailUsername, replyTo, newSendFromName) {
      const req = new ChangeEmailDomainRequest({
        senderType: senderType,
        senderId: senderID,
        sendFromDomain: newDomain,
        sendFromUsername: newEmailUsername,
        replyToEmail: replyTo,
        sendFromName: newSendFromName
      });
      return this.api.changeEmailDomain(req).pipe(map(v => v.status));
    }
    createPendingDomain(senderType, senderId, domain) {
      return this.domain.createPendingDomain({
        sender: new Sender({
          type: senderType,
          id: senderId
        }),
        domain: domain
      });
    }
    deletePendingDomain(senderType, senderId, domain) {
      return this.api.deletePendingEmailDomain({
        senderType: senderType,
        senderId: senderId,
        domain: domain
      }).pipe(map(() => null));
    }
    /**
     * Requests the pending domain for an email sender
     * @param senderType The sender type, (ex. partner, business)
     * @param senderID the sender ID, (ex. partnerID, businessID)
     */
    getPendingEmailDomain(senderType, senderID) {
      const req = new GetPendingEmailDomainRequest({
        senderType: senderType,
        senderId: senderID
      });
      return this.api.getPendingEmailDomain(req);
    }
    verifyPendingDomain(senderType, senderID) {
      const req = new VerifyPendingEmailDomainRequest({
        senderType: senderType,
        senderId: senderID
      });
      return this.api.verifyPendingEmailDomain(req).pipe(map(v => {
        v.allRecordsMatch = Boolean(v.allRecordsMatch);
        v.mismatches = v.mismatches || [];
        return v;
      }));
    }
    verifyDefaultDomain(senderType, senderId) {
      const req = new VerifyDefaultDomainRequest({
        sender: {
          type: senderType,
          id: senderId
        }
      });
      return this.domain.verifyDefaultDomain(req).pipe(map(v => ({
        allRecordsMatch: Boolean(v.allRecordsMatch),
        mismatches: v.mismatches || []
      })));
    }
    listAllDomains(senderType, senderID) {
      const req = new ListAllDomainsRequest({
        sender: {
          type: senderType,
          id: senderID
        }
      });
      return this.domain.listAllDomains(req).pipe(map(v => {
        v.domains = v.domains || [];
        return v;
      }));
    }
    getDefaultDomain(senderType) {
      const req = new GetDefaultDomainRequest({
        senderType: senderType
      });
      return this.domain.getDefaultDomain(req);
    }
    verifyDMARC(sender) {
      const req = new VerifyEmailDomainDMARCRequest({
        sender: sender
      });
      return this.domain.verifyEmailDomainDmarc(req);
    }
  }
  DomainService.ɵfac = function DomainService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DomainService)(i0.ɵɵinject(EmailApiService), i0.ɵɵinject(DomainApiService));
  };
  DomainService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DomainService,
    factory: DomainService.ɵfac,
    providedIn: 'root'
  });
  return DomainService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MessageService = /*#__PURE__*/(() => {
  class MessageService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    getMessage(emailID) {
      const req = {
        emailId: emailID
      };
      return this.delegate.getMessage(req).pipe(map(v => v.message));
    }
  }
  MessageService.ɵfac = function MessageService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MessageService)(i0.ɵɵinject(MessageApiService));
  };
  MessageService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MessageService,
    factory: MessageService.ɵfac,
    providedIn: 'root'
  });
  return MessageService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PreferencesService = /*#__PURE__*/(() => {
  class PreferencesService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    getCategories(senderType, senderID) {
      const req = new GetCategoriesRequest({
        senderType: senderType,
        senderId: senderID
      });
      return this.delegate.getCategories(req);
    }
    saveCategoryPreferencesForUser(senderType, senderID, recipientUserID, optedInEmailCategoryIDs) {
      const req = new SaveCategoryPreferencesRequest({
        senderType: senderType,
        senderId: senderID,
        userId: recipientUserID,
        optedInEmailCategoryIds: optedInEmailCategoryIDs
      });
      return this.delegate.saveCategoryPreferences(req);
    }
    getCategoryPreferences(senderType, senderID, recipientID) {
      const req = new GetCategoryPreferencesRequest({
        senderType: senderType,
        senderId: senderID,
        recipientId: recipientID
      });
      return this.delegate.getCategoryPreferences(req);
    }
    getUnsubscribeLink(linkID) {
      return this.delegate.getUnsubscribeLink({
        id: linkID
      });
    }
  }
  PreferencesService.ɵfac = function PreferencesService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || PreferencesService)(i0.ɵɵinject(PreferencesApiService));
  };
  PreferencesService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: PreferencesService,
    factory: PreferencesService.ɵfac,
    providedIn: 'root'
  });
  return PreferencesService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmailClientService = /*#__PURE__*/(() => {
  class EmailClientService {
    constructor(api) {
      this.api = api;
    }
    resubscribeRecipientFromUnsubscribeLink(unsubscribeLinkId) {
      const req = new ResubscribeRecipientFromUnsubscribeLinkRequest({
        unsubscribeLinkId: unsubscribeLinkId
      });
      return this.api.resubscribeRecipientFromUnsubscribeLink(req);
    }
  }
  EmailClientService.ɵfac = function EmailClientService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailClientService)(i0.ɵɵinject(EmailClientApiService));
  };
  EmailClientService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmailClientService,
    factory: EmailClientService.ɵfac,
    providedIn: 'root'
  });
  return EmailClientService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RecipientStatusService = /*#__PURE__*/(() => {
  class RecipientStatusService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    // MAX email list size is 500
    searchRecipientStatus(senderType, senderID, recipientEmails) {
      return this.delegate.batchSearchRecipientStatus({
        sender: {
          type: senderType,
          id: senderID
        },
        recipientEmails: recipientEmails
      });
    }
  }
  RecipientStatusService.ɵfac = function RecipientStatusService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || RecipientStatusService)(i0.ɵɵinject(RecipientStatusApiService));
  };
  RecipientStatusService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: RecipientStatusService,
    factory: RecipientStatusService.ɵfac,
    providedIn: 'root'
  });
  return RecipientStatusService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmailModule = /*#__PURE__*/(() => {
  class EmailModule {}
  EmailModule.ɵfac = function EmailModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || EmailModule)();
  };
  EmailModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: EmailModule
  });
  EmailModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    providers: [EmailService, EmailEventService, SendgridSubUsersService, SendgridTeammatesService, DomainService, AdminService, MessageService, PreferencesService, RecipientStatusService, EmailClientService]
  });
  return EmailModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SendersService = /*#__PURE__*/(() => {
  class SendersService {
    constructor(senders) {
      this.senders = senders;
    }
    getEmailSendingInfo(senderType, senderId) {
      const req = {
        sender: {
          type: senderType,
          id: senderId
        }
      };
      return this.senders.getSenderInfo(req);
    }
  }
  SendersService.ɵfac = function SendersService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SendersService)(i0.ɵɵinject(SendersApiService));
  };
  SendersService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SendersService,
    factory: SendersService.ɵfac,
    providedIn: 'root'
  });
  return SendersService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const MARKETING_SERVICE_PROVIDER_ID = 'ESP_MARKETING';
let MessageSendingService = /*#__PURE__*/(() => {
  class MessageSendingService {
    constructor(emailClientApi) {
      this.emailClientApi = emailClientApi;
    }
    sendMarketingEmailFromPartner(fromName, fromEmailAddress, recipientUserID, subjectLine, emailContentHtml, partnerID, replyToName, replyToEmailAddress, options) {
      const req = this.buildSendRequest(fromName, fromEmailAddress, recipientUserID, subjectLine, emailContentHtml, MARKETING_SERVICE_PROVIDER_ID, partnerID, replyToName, replyToEmailAddress, "", "", options);
      return this.emailClientApi.sendV2(req);
    }
    sendMarketingEmailFromBusiness(fromName, fromEmailAddress, recipientUserID, subjectLine, emailContentHtml, partnerID, businessID, replyToName, replyToEmailAddress, options) {
      const req = this.buildSendRequest(fromName, fromEmailAddress, recipientUserID, subjectLine, emailContentHtml, MARKETING_SERVICE_PROVIDER_ID, partnerID, replyToName, replyToEmailAddress, "", businessID, options);
      return this.emailClientApi.sendV2(req);
    }
    buildSendRequest(fromName, fromEmailAddress, recipientUserID, subjectLine, emailContentHtml, espID, partnerID, replyToName, replyToEmailAddress, applicationID, businessID, options) {
      const message = new EmailMessageV2({
        to: {
          userId: recipientUserID
        },
        from: {
          name: fromName,
          emailAddress: fromEmailAddress
        },
        subject: subjectLine,
        content: [{
          type: ContentContentType.TEXT_HTML,
          value: emailContentHtml
        }]
      });
      if (!!replyToName && !!replyToEmailAddress) {
        message.replyTo = {
          name: replyToName,
          emailAddress: replyToEmailAddress
        };
      }
      if (!!options) {
        if (!!options.attributes) {
          message.attributes = options.attributes;
        }
        if (!!options.headers) {
          message.headers = options.headers;
        }
        if (!!options.attachments) {
          message.attachments = options.attachments;
        }
        if (!!options.urlAttachments) {
          message.urlAttachments = options.urlAttachments;
        }
      }
      const req = new SendV2Request({
        email: message,
        partnerId: partnerID,
        espId: espID,
        applicationId: applicationID ? applicationID : '',
        businessId: businessID ? businessID : ''
      });
      if (!!applicationID) {
        req.applicationId = applicationID;
      }
      if (!!businessID) {
        req.businessId = businessID;
      }
      if (!!options?.idempotencyKey) {
        req.idempotencyKey = options.idempotencyKey;
      }
      return req;
    }
  }
  MessageSendingService.ɵfac = function MessageSendingService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || MessageSendingService)(i0.ɵɵinject(EmailApiService));
  };
  MessageSendingService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: MessageSendingService,
    factory: MessageSendingService.ɵfac,
    providedIn: 'root'
  });
  return MessageSendingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BlockService = /*#__PURE__*/(() => {
  class BlockService {
    constructor(api) {
      this.api = api;
    }
    createBlock(blockType, message, conditions) {
      const req = new CreateBlockRequest({
        blockType: blockType,
        message: message,
        conditions: conditions
      });
      return this.api.createBlock(req);
    }
    getBlock(blockType, id) {
      const req = new GetBlockRequest({
        blockType: blockType,
        id: id
      });
      return this.api.getBlock(req);
    }
    deleteBlock(blockType, id) {
      const req = new DeleteBlockRequest({
        blockType: blockType,
        id: id
      });
      return this.api.deleteBlock(req);
    }
  }
  BlockService.ɵfac = function BlockService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || BlockService)(i0.ɵɵinject(BlocksApiService));
  };
  BlockService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: BlockService,
    factory: BlockService.ɵfac,
    providedIn: 'root'
  });
  return BlockService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, AdminService, AdminSetEmailQueuesStatusRequest, AttachmentInfo, Attribute, BatchSearchRecipientStatusRequest, BatchSearchRecipientStatusResponse, BlockService, BounceSender, BounceSenderType, Bucket, BulkUpsertPartnerEmailQuotaRequest, Category, ChangeEmailDomainRequest, ChangeEmailDomainResponse, ChangeEmailDomainStatus, CheckDisposableEmailRequest, CheckDisposableEmailResponse, ContactParticipant, Content, ContentContentType, CreateBlockRequest, CreateBlockResponse, CreateEmailDomainRequest, CreateEmailDomainWithSendAsRequest, CreateInboundMessageMappingRequest, CreateInboundMessageMappingResponse, CreatePendingDomainRequest, CustomSender, DateRange, DeleteBlockRequest, DeleteEmailDomainRequest, DeletePartnerEmailQuotaRequest, DeletePendingEmailDomainRequest, DeleteSubUserRequest, DomainService, EmailClientService, EmailDomain, EmailEvent, EmailEventBucket, EmailEventBucketEventRollup, EmailEventFilter, EmailEventService, EmailMessage, EmailMessageV2, EmailModule, EmailQueueStatus, EmailService, EmailWithCustomDomainMessage, Envelope, EventType, ExportAttributeEventClickStatsRequest, GCSAttachment, GetAttributeEventLinkStatsRequest, GetAttributeEventLinkStatsResponse, GetAttributeEventStatsRequest, GetAttributeEventStatsResponse, GetAttributeEventStatsResponseEventStats, GetBlockRequest, GetBlockResponse, GetBouncedRecipientRequest, GetBouncedRecipientResponse, GetCategoriesRequest, GetCategoriesResponse, GetCategoryPreferencesRequest, GetCategoryPreferencesResponse, GetDefaultDomainRequest, GetDefaultDomainResponse, GetEmailDomainRequest, GetEmailDomainResponse, GetEmailQueuesStatusRequest, GetEmailQueuesStatusResponse, GetInboundMessageMappingRequest, GetInboundMessageMappingResponse, GetInboundMessageRequest, GetInboundMessageResponse, GetMessageRequest, GetMessageResponse, GetMultiEmailRollupsRequest, GetMultiEmailRollupsResponse, GetMultiMessageRequest, GetMultiMessageResponse, GetMultiPartnerEmailQuotaRequest, GetMultiPartnerEmailQuotaResponse, GetPendingEmailDomainRequest, GetPendingEmailDomainResponse, GetPendingEmailDomainTargetCNameRecords, GetReplyEmailRequest, GetReplyEmailResponse, GetSenderInfoRequest, GetSenderInfoResponse, GetUnsubscribeLinkRequest, GetUnsubscribeLinkResponse, GetUnsubscribedRecipientRequest, GetUnsubscribedRecipientResponse, Header, InboundMessage, InboundMessageMapping, InboundMessageMappingOptions, InitializeSubUserRequest, InitiateEmailDomainRectifyRequest, InitiateEmailDomainRollbackRequest, LinkClickStats, LinkClickStatsRecipient, LinkStats, Links, ListAllDomainsRequest, ListAllDomainsResponse, ListEmailEventsRequest, ListEmailEventsRequestListEmailEventsFilters, ListEmailEventsResponse, ListEmailsRequest, ListEmailsRequestListEmailsFilters, ListEmailsResponse, ListEventsForAttributesRequest, ListEventsForAttributesResponse, ListLinkClickActivityForAttributeRequest, ListLinkClickActivityForAttributeRequestPagedRequestOptions, ListLinkClickActivityForAttributeResponse, ListSendGridSubUserReputationsRequest, ListSendGridSubUserReputationsResponse, ListSendGridTeammatesRequest, ListSendGridTeammatesResponse, MessageSendingService, MessageService, Namespace, NotificationType, PagedRequestOptions, PagedResponseMetadata, Participant, PartnerEmailQuota, PartnerEmailQuotaMutation, PreferencesService, QuarantineSenderRequest, RecipientStatusEnum, RecipientStatusService, Record, RedirectEmailRequest, RedirectEmailResponse, ResetRecipientStatusRequest, ResubscribeRecipientFromUnsubscribeLinkRequest, ResubscribeRecipientRequest, SaveCategoryPreferencesRequest, SendFromAuthorizedDomainRequest, SendFromAuthorizedDomainResponse, SendGridSubUserReputation, SendGridTeammate, SendRequest, SendResponse, SendV2Request, SendV2Response, SendWhitelabelEmailToUserRequest, SendWhitelabelEmailToUserResponse, SendWithCustomDomainRequest, SendWithCustomDomainResponse, Sender, SenderDomain, SenderType, SendersService, SendgridSubUsersService, SendgridTeammatesService, ServiceProviderInfo, SetEmailQueuesStatusRequest, Status, URLAttachment, UnbounceRecipientRequest, UpsertPartnerEmailQuotaRequest, UserParticipant, VerifyDefaultDomainMismatch, VerifyDefaultDomainRequest, VerifyDefaultDomainResponse, VerifyEmailDomainDMARCRequest, VerifyEmailDomainDMARCResponse, VerifyEmailDomainRequest, VerifyPendingEmailDomainMismatch, VerifyPendingEmailDomainRequest, VerifyPendingEmailDomainResponse, WhiteLabelEmailMessage };
